import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  /** ActionDispatch::Http::UploadedFile */
  File: any;
};

/** Autogenerated input type of AcceptEvent */
export type AcceptEventInput = {
  id: Scalars['ID'];
  event: EventInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of AcceptEvent */
export type AcceptEventPayload = {
  __typename?: 'AcceptEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
};

/** Autogenerated input type of AcceptRequest */
export type AcceptRequestInput = {
  id: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of AcceptRequest */
export type AcceptRequestPayload = {
  __typename?: 'AcceptRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  request?: Maybe<RequestType>;
};

/** Autogenerated input type of AddGroupActivity */
export type AddGroupActivityInput = {
  attributes: GroupActivityAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of AddGroupActivity */
export type AddGroupActivityPayload = {
  __typename?: 'AddGroupActivityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  group?: Maybe<GroupType>;
};

/** Autogenerated input type of AddGroupComment */
export type AddGroupCommentInput = {
  id: Scalars['ID'];
  attributes: CommentInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of AddGroupComment */
export type AddGroupCommentPayload = {
  __typename?: 'AddGroupCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  comment?: Maybe<GroupCommentType>;
  error?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of Address */
export type AddressInput = {
  id: Scalars['ID'];
  address: AddressInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddressInputType = {
  industryTypeId?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderText?: Maybe<Scalars['String']>;
  birthdayYear?: Maybe<Scalars['String']>;
  birthdayMonth?: Maybe<Scalars['String']>;
  birthdayDay?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyNameKana?: Maybe<Scalars['String']>;
  companyBranchName?: Maybe<Scalars['String']>;
  companyPosition?: Maybe<Scalars['String']>;
  companyTel?: Maybe<Scalars['String']>;
  companyFax?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of Address */
export type AddressPayload = {
  __typename?: 'AddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  order?: Maybe<OrderType>;
};

export type AddressType = {
  __typename?: 'AddressType';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  birthdayDay?: Maybe<Scalars['String']>;
  birthdayMonth?: Maybe<Scalars['String']>;
  birthdayYear?: Maybe<Scalars['String']>;
  companyBranchName?: Maybe<Scalars['String']>;
  companyFax?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyNameKana?: Maybe<Scalars['String']>;
  companyPosition?: Maybe<Scalars['String']>;
  companyTel?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  industryType?: Maybe<IndustryTypeType>;
  industryTypeId?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['ID']>;
  tel?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ApplyCouponToEvent */
export type ApplyCouponToEventInput = {
  id: Scalars['ID'];
  coupon: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ApplyCouponToEvent */
export type ApplyCouponToEventPayload = {
  __typename?: 'ApplyCouponToEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
};

/** Autogenerated input type of ApplyEvent */
export type ApplyEventInput = {
  id: Scalars['ID'];
  event: EventInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ApplyEvent */
export type ApplyEventPayload = {
  __typename?: 'ApplyEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
};

export type BankInputType = {
  name?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
};

export type BankType = {
  __typename?: 'BankType';
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  accountTypeText?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of CancelOrder */
export type CancelOrderInput = {
  id: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CancelOrder */
export type CancelOrderPayload = {
  __typename?: 'CancelOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  order?: Maybe<OrderType>;
};

/** Autogenerated input type of ChangePassword */
export type ChangePasswordInput = {
  password: PasswordAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ChangePassword */
export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
};

export type CommentInputType = {
  message?: Maybe<Scalars['String']>;
  isEdit?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of Confirm */
export type ConfirmInput = {
  token: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of Confirm */
export type ConfirmPayload = {
  __typename?: 'ConfirmPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
};

export type Contact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
};

export type ContactAttributes = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateContact */
export type CreateContactInput = {
  attributes: ContactAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateContact */
export type CreateContactPayload = {
  __typename?: 'CreateContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  contact?: Maybe<Contact>;
  error?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateEvent */
export type CreateEventInput = {
  event: EventInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateEvent */
export type CreateEventPayload = {
  __typename?: 'CreateEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
};

/** Autogenerated input type of CreateEventSchedule */
export type CreateEventScheduleInput = {
  eventSchedule: EventScheduleInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateEventSchedule */
export type CreateEventSchedulePayload = {
  __typename?: 'CreateEventSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
};

/** Autogenerated input type of CreateGroup */
export type CreateGroupInput = {
  group: GroupInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateGroup */
export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  group?: Maybe<GroupType>;
};

/** Autogenerated input type of CreateNotification */
export type CreateNotificationInput = {
  attributes: NotificationAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateNotification */
export type CreateNotificationPayload = {
  __typename?: 'CreateNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  notification?: Maybe<Notification>;
};

/** Autogenerated input type of CreatePayjpCustomer */
export type CreatePayjpCustomerInput = {
  attributes: PayjpCustomerAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreatePayjpCustomer */
export type CreatePayjpCustomerPayload = {
  __typename?: 'CreatePayjpCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  payjpCustomer?: Maybe<PayjpCustomerType>;
};

/** Autogenerated input type of CreatePayment */
export type CreatePaymentInput = {
  attributes: PaymentInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreatePayment */
export type CreatePaymentPayload = {
  __typename?: 'CreatePaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  payment?: Maybe<PaymentType>;
};

/** Autogenerated input type of CreateRequest */
export type CreateRequestInput = {
  request: RequestInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateRequest */
export type CreateRequestPayload = {
  __typename?: 'CreateRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  group?: Maybe<GroupType>;
};

/** Autogenerated input type of CreateRoomCalendar */
export type CreateRoomCalendarInput = {
  roomCalendar: RoomCalendarInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateRoomCalendar */
export type CreateRoomCalendarPayload = {
  __typename?: 'CreateRoomCalendarPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  roomCalendar?: Maybe<RoomCalendarType>;
};


/** Autogenerated input type of DestroyGroupUser */
export type DestroyGroupUserInput = {
  id: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DestroyGroupUser */
export type DestroyGroupUserPayload = {
  __typename?: 'DestroyGroupUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  group?: Maybe<GroupType>;
};

export type EventInputType = {
  eventStatus?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  locationType?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  ticketQuantity?: Maybe<Scalars['Int']>;
  ticketAmount?: Maybe<Scalars['Int']>;
  isFree?: Maybe<Scalars['Boolean']>;
  dueDate?: Maybe<Scalars['String']>;
  dueTime?: Maybe<Scalars['String']>;
  cancelDate?: Maybe<Scalars['String']>;
  cancelTime?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  organizer?: Maybe<Scalars['String']>;
  informationEmail?: Maybe<Scalars['String']>;
  informationTel?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  onShowpage?: Maybe<Scalars['Boolean']>;
  isShowEventList?: Maybe<Scalars['Boolean']>;
  eventType?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['File']>;
  eventSchedules?: Maybe<Array<EventScheduleInputType>>;
  ticketPaymentMethod?: Maybe<Scalars['String']>;
  ownerPaymentStatus?: Maybe<Scalars['String']>;
  isReceipt?: Maybe<Scalars['Boolean']>;
  receiptName?: Maybe<Scalars['String']>;
  ownerPaymentDate?: Maybe<Scalars['String']>;
  receiptStatus?: Maybe<Scalars['String']>;
  akerunStatus?: Maybe<Scalars['String']>;
};

export type EventOptionInputType = {
  eventId?: Maybe<Scalars['ID']>;
  optionId?: Maybe<Scalars['ID']>;
  isApply?: Maybe<Scalars['String']>;
};

export type EventOptionType = {
  __typename?: 'EventOptionType';
  eventId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  isApply?: Maybe<Scalars['Boolean']>;
  option?: Maybe<OptionType>;
  optionId?: Maybe<Scalars['ID']>;
};

export type EventScheduleInputType = {
  eventId?: Maybe<Scalars['ID']>;
  eventDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
};

export type EventScheduleType = {
  __typename?: 'EventScheduleType';
  endTime?: Maybe<Scalars['String']>;
  endTimeText?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['Date']>;
  eventDateText?: Maybe<Scalars['String']>;
  eventDateTextFull?: Maybe<Scalars['String']>;
  eventDateWday?: Maybe<Scalars['String']>;
  eventDatetimeText?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  startTime?: Maybe<Scalars['String']>;
  startTimeText?: Maybe<Scalars['String']>;
};

export type EventSearch = {
  eventType?: Maybe<Array<Scalars['String']>>;
  eventStatus?: Maybe<Array<Scalars['String']>>;
  paymentStatus?: Maybe<Array<Scalars['String']>>;
  paymentMethod?: Maybe<Array<Scalars['String']>>;
  ownerPaymentStatus?: Maybe<Array<Scalars['String']>>;
  akerunStatus?: Maybe<Array<Scalars['String']>>;
  fromDate?: Maybe<Scalars['String']>;
  toDate?: Maybe<Scalars['String']>;
};

export type EventType = {
  __typename?: 'EventType';
  acceptedOrders?: Maybe<Array<Maybe<OrderType>>>;
  acmPrice?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  akerunStatus?: Maybe<Scalars['String']>;
  akerunStatusText?: Maybe<Scalars['String']>;
  canCancel?: Maybe<Scalars['Boolean']>;
  cancelDate?: Maybe<Scalars['String']>;
  cancelDateText?: Maybe<Scalars['String']>;
  cancelTime?: Maybe<Scalars['String']>;
  cancelTimeText?: Maybe<Scalars['String']>;
  chargeId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  dueDateText?: Maybe<Scalars['String']>;
  dueTime?: Maybe<Scalars['String']>;
  dueTimeText?: Maybe<Scalars['String']>;
  endTimeText?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['Date']>;
  eventDateText?: Maybe<Scalars['String']>;
  eventDateWday?: Maybe<Scalars['String']>;
  eventDatetimeText?: Maybe<Scalars['String']>;
  eventOptions?: Maybe<Array<Maybe<EventOptionType>>>;
  eventSchedules?: Maybe<Array<Maybe<EventScheduleType>>>;
  eventStatus?: Maybe<Scalars['String']>;
  eventStatusText?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  eventTypeText?: Maybe<Scalars['String']>;
  group?: Maybe<GroupType>;
  groupId?: Maybe<Scalars['ID']>;
  guestCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  informationEmail?: Maybe<Scalars['String']>;
  informationTel?: Maybe<Scalars['String']>;
  isFree?: Maybe<Scalars['Boolean']>;
  isReceipt?: Maybe<Scalars['Boolean']>;
  isShowEventList?: Maybe<Scalars['Boolean']>;
  lastEventDateText?: Maybe<Scalars['String']>;
  lastEventDateWday?: Maybe<Scalars['String']>;
  lastEventDatetimeText?: Maybe<Scalars['String']>;
  lastStartTimeText?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  locationType?: Maybe<Scalars['String']>;
  locationTypeText?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  mainImageUrl?: Maybe<Scalars['String']>;
  onShowpage?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<Maybe<OptionType>>>;
  orderCount?: Maybe<Scalars['Int']>;
  orders?: Maybe<Array<Maybe<OrderType>>>;
  organizer?: Maybe<Scalars['String']>;
  overFirstEventDate?: Maybe<Scalars['Boolean']>;
  ownerPaymentDate?: Maybe<Scalars['String']>;
  ownerPaymentStatus?: Maybe<Scalars['String']>;
  ownerPaymentStatusText?: Maybe<Scalars['String']>;
  payment?: Maybe<PaymentType>;
  paymentStatus?: Maybe<Scalars['String']>;
  paymentStatusText?: Maybe<Scalars['String']>;
  receiptName?: Maybe<Scalars['String']>;
  receiptStatus?: Maybe<Scalars['String']>;
  receiptStatusText?: Maybe<Scalars['String']>;
  roomCalendars?: Maybe<Array<Maybe<RoomCalendarType>>>;
  startTimeText?: Maybe<Scalars['String']>;
  taxAcmPrice?: Maybe<Scalars['Int']>;
  ticketAmount?: Maybe<Scalars['Int']>;
  ticketPaymentMethod?: Maybe<Scalars['String']>;
  ticketPaymentMethodText?: Maybe<Scalars['String']>;
  ticketQuantity?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  totalFee?: Maybe<Scalars['Int']>;
  totalPaymentPrice?: Maybe<Scalars['Int']>;
  totalSalesPrice?: Maybe<Scalars['Int']>;
  user?: Maybe<UserType>;
};

export type EventsType = {
  __typename?: 'EventsType';
  events?: Maybe<Array<Maybe<EventType>>>;
  pagination?: Maybe<Pagination>;
};


/** Autogenerated input type of Follow */
export type FollowInput = {
  groupId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of Follow */
export type FollowPayload = {
  __typename?: 'FollowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  group?: Maybe<GroupType>;
};

export type FollowType = {
  __typename?: 'FollowType';
  groupId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  user?: Maybe<UserType>;
  userId?: Maybe<Scalars['ID']>;
};

export type GroupActivityAttributes = {
  groupId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type GroupActivityType = {
  __typename?: 'GroupActivityType';
  comments?: Maybe<Array<Maybe<GroupCommentType>>>;
  groupId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type GroupCommentType = {
  __typename?: 'GroupCommentType';
  createdAtText?: Maybe<Scalars['String']>;
  groupActivityId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  isEdit?: Maybe<Scalars['Boolean']>;
  isRemove?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
  userId?: Maybe<Scalars['ID']>;
};

export type GroupInputType = {
  name?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
};

export type GroupMailInputType = {
  groupId?: Maybe<Scalars['ID']>;
  subject?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type GroupMailType = {
  __typename?: 'GroupMailType';
  groupId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type GroupType = {
  __typename?: 'GroupType';
  activities?: Maybe<Array<Maybe<GroupActivityType>>>;
  content?: Maybe<Scalars['String']>;
  followers?: Maybe<Array<Maybe<FollowType>>>;
  groupAdminCount?: Maybe<Scalars['Int']>;
  groupAdmins?: Maybe<Array<Maybe<GroupUserType>>>;
  groupFollowerCount?: Maybe<Scalars['Int']>;
  groupMemberCount?: Maybe<Scalars['Int']>;
  groupMembers?: Maybe<Array<Maybe<GroupUserType>>>;
  groupUsers?: Maybe<Array<Maybe<GroupUserType>>>;
  id?: Maybe<Scalars['ID']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  mainImageUrl?: Maybe<Scalars['String']>;
  myRequestStatus?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  requests?: Maybe<Array<Maybe<RequestType>>>;
  users?: Maybe<Array<Maybe<UserType>>>;
};

export type GroupUserInputType = {
  role?: Maybe<Scalars['String']>;
};

export type GroupUserType = {
  __typename?: 'GroupUserType';
  groupId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  role?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
  userId?: Maybe<Scalars['ID']>;
};

export type GroupsType = {
  __typename?: 'GroupsType';
  groups?: Maybe<Array<Maybe<GroupType>>>;
  pagination?: Maybe<Pagination>;
};

export type IndustryTypeType = {
  __typename?: 'IndustryTypeType';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptEvent?: Maybe<AcceptEventPayload>;
  acceptRequest?: Maybe<AcceptRequestPayload>;
  addGroupActivity?: Maybe<AddGroupActivityPayload>;
  addGroupComment?: Maybe<AddGroupCommentPayload>;
  address?: Maybe<AddressPayload>;
  applyCouponToEvent?: Maybe<ApplyCouponToEventPayload>;
  applyEvent?: Maybe<ApplyEventPayload>;
  cancelOrder?: Maybe<CancelOrderPayload>;
  changePassword: ChangePasswordPayload;
  confirm?: Maybe<ConfirmPayload>;
  createContact?: Maybe<CreateContactPayload>;
  createEvent?: Maybe<CreateEventPayload>;
  createEventSchedule?: Maybe<CreateEventSchedulePayload>;
  createGroup?: Maybe<CreateGroupPayload>;
  createNotification?: Maybe<CreateNotificationPayload>;
  createPayjpCustomer?: Maybe<CreatePayjpCustomerPayload>;
  createPayment?: Maybe<CreatePaymentPayload>;
  createRequest?: Maybe<CreateRequestPayload>;
  createRoomCalendar?: Maybe<CreateRoomCalendarPayload>;
  destroyGroupUser?: Maybe<DestroyGroupUserPayload>;
  follow?: Maybe<FollowPayload>;
  order?: Maybe<OrderPayload>;
  payment?: Maybe<PaymentPayload>;
  rejectEvent?: Maybe<RejectEventPayload>;
  rejectRequest?: Maybe<RejectRequestPayload>;
  removeEvent?: Maybe<RemoveEventPayload>;
  removeEventSchedule?: Maybe<RemoveEventSchedulePayload>;
  removeGroupActivity?: Maybe<RemoveGroupActivityPayload>;
  removeGroupComment?: Maybe<RemoveGroupCommentPayload>;
  removeRoomCalendar?: Maybe<RemoveRoomCalendarPayload>;
  requestPasswordReset?: Maybe<RequestPasswordResetPayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  revertEvent?: Maybe<RevertEventPayload>;
  sendGroupMail?: Maybe<SendGroupMailPayload>;
  signin: SigninPayload;
  signout: SignoutPayload;
  signup: SignupPayload;
  unfollow?: Maybe<UnFollowPayload>;
  updateAddress?: Maybe<UpdateAddressPayload>;
  updateBank?: Maybe<UpdateBankPayload>;
  updateEvent?: Maybe<UpdateEventPayload>;
  updateEventOption?: Maybe<UpdateEventOptionPayload>;
  updateEventSchedule?: Maybe<UpdateEventSchedulePayload>;
  updateGroup?: Maybe<UpdateGroupPayload>;
  updateGroupActivity?: Maybe<UpdateGroupActivityPayload>;
  updateGroupComment?: Maybe<UpdateGroupCommentPayload>;
  updateGroupUser?: Maybe<UpdateGroupUserPayload>;
  updateNotification?: Maybe<UpdateNotificationPayload>;
  updateOrder?: Maybe<UpdateOrderPayload>;
  updatePassword?: Maybe<UpdatePasswordPayload>;
  updatePayjpCustomer?: Maybe<UpdatePayjpCustomerPayload>;
  updatePayment?: Maybe<UpdatePaymentPayload>;
  updateRequest?: Maybe<UpdateRequestPayload>;
  updateRoomCalendar?: Maybe<UpdateRoomCalendarPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
};


export type MutationAcceptEventArgs = {
  input: AcceptEventInput;
};


export type MutationAcceptRequestArgs = {
  input: AcceptRequestInput;
};


export type MutationAddGroupActivityArgs = {
  input: AddGroupActivityInput;
};


export type MutationAddGroupCommentArgs = {
  input: AddGroupCommentInput;
};


export type MutationAddressArgs = {
  input: AddressInput;
};


export type MutationApplyCouponToEventArgs = {
  input: ApplyCouponToEventInput;
};


export type MutationApplyEventArgs = {
  input: ApplyEventInput;
};


export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationConfirmArgs = {
  input: ConfirmInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationCreateEventScheduleArgs = {
  input: CreateEventScheduleInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


export type MutationCreatePayjpCustomerArgs = {
  input: CreatePayjpCustomerInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreateRequestArgs = {
  input: CreateRequestInput;
};


export type MutationCreateRoomCalendarArgs = {
  input: CreateRoomCalendarInput;
};


export type MutationDestroyGroupUserArgs = {
  input: DestroyGroupUserInput;
};


export type MutationFollowArgs = {
  input: FollowInput;
};


export type MutationOrderArgs = {
  input: OrderInput;
};


export type MutationPaymentArgs = {
  input: PaymentInput;
};


export type MutationRejectEventArgs = {
  input: RejectEventInput;
};


export type MutationRejectRequestArgs = {
  input: RejectRequestInput;
};


export type MutationRemoveEventArgs = {
  input: RemoveEventInput;
};


export type MutationRemoveEventScheduleArgs = {
  input: RemoveEventScheduleInput;
};


export type MutationRemoveGroupActivityArgs = {
  input: RemoveGroupActivityInput;
};


export type MutationRemoveGroupCommentArgs = {
  input: RemoveGroupCommentInput;
};


export type MutationRemoveRoomCalendarArgs = {
  input: RemoveRoomCalendarInput;
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationRevertEventArgs = {
  input: RevertEventInput;
};


export type MutationSendGroupMailArgs = {
  input: SendGroupMailInput;
};


export type MutationSigninArgs = {
  input: SigninInput;
};


export type MutationSignoutArgs = {
  input: SignoutInput;
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationUnfollowArgs = {
  input: UnFollowInput;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateBankArgs = {
  input: UpdateBankInput;
};


export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};


export type MutationUpdateEventOptionArgs = {
  input: UpdateEventOptionInput;
};


export type MutationUpdateEventScheduleArgs = {
  input: UpdateEventScheduleInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateGroupActivityArgs = {
  input: UpdateGroupActivityInput;
};


export type MutationUpdateGroupCommentArgs = {
  input: UpdateGroupCommentInput;
};


export type MutationUpdateGroupUserArgs = {
  input: UpdateGroupUserInput;
};


export type MutationUpdateNotificationArgs = {
  input: UpdateNotificationInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdatePayjpCustomerArgs = {
  input: UpdatePayjpCustomerInput;
};


export type MutationUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};


export type MutationUpdateRequestArgs = {
  input: UpdateRequestInput;
};


export type MutationUpdateRoomCalendarArgs = {
  input: UpdateRoomCalendarInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type Notification = {
  __typename?: 'Notification';
  endDate?: Maybe<Scalars['Date']>;
  endDateText?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  startDateText?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  statusText?: Maybe<Scalars['String']>;
};

export type NotificationAttributes = {
  status?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};

export type Notifications = {
  __typename?: 'Notifications';
  notifications?: Maybe<Array<Maybe<Notification>>>;
  pagination?: Maybe<Pagination>;
};

export type OptionSearch = {
  optionType?: Maybe<Scalars['String']>;
};

export type OptionType = {
  __typename?: 'OptionType';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  optionType?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
};

/** Autogenerated input type of Order */
export type OrderInput = {
  id: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type OrderInputType = {
  paymentState?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of Order */
export type OrderPayload = {
  __typename?: 'OrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  order?: Maybe<OrderType>;
};

export type OrderType = {
  __typename?: 'OrderType';
  chargeId?: Maybe<Scalars['String']>;
  completedAtText?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
  id?: Maybe<Scalars['ID']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentStateText?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Scalars['Int']>;
  user?: Maybe<UserType>;
  workflowState?: Maybe<Scalars['String']>;
  workflowStateText?: Maybe<Scalars['String']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  currentPage?: Maybe<Scalars['Int']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  nextPage?: Maybe<Scalars['Int']>;
  previousPage?: Maybe<Scalars['Int']>;
  resultsCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PasswordAttributes = {
  currentPassword?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  passwordConfirmation?: Maybe<Scalars['String']>;
};

export type PayjpCardType = {
  __typename?: 'PayjpCardType';
  cardId?: Maybe<Scalars['ID']>;
  created?: Maybe<Scalars['Int']>;
  customerId?: Maybe<Scalars['ID']>;
  expMonth?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  last4?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PayjpCustomerAttributes = {
  token?: Maybe<Scalars['String']>;
};

export type PayjpCustomerType = {
  __typename?: 'PayjpCustomerType';
  card?: Maybe<PayjpCardType>;
  customerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of Payment */
export type PaymentInput = {
  id: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type PaymentInputType = {
  eventId?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of Payment */
export type PaymentPayload = {
  __typename?: 'PaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  order?: Maybe<OrderType>;
};

export type PaymentType = {
  __typename?: 'PaymentType';
  eventId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  payjpCard?: Maybe<PayjpCardType>;
  paymentMethod?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  allUsers?: Maybe<Array<UserType>>;
  bank?: Maybe<BankType>;
  currentOrder?: Maybe<OrderType>;
  currentUser?: Maybe<UserType>;
  event?: Maybe<EventType>;
  events?: Maybe<EventsType>;
  group?: Maybe<GroupType>;
  groupActivities?: Maybe<Array<Maybe<GroupActivityType>>>;
  groupFeatureEvents: Array<Maybe<EventType>>;
  groupPastEvents: Array<Maybe<EventType>>;
  groups?: Maybe<GroupsType>;
  industryTypes?: Maybe<Array<Maybe<IndustryTypeType>>>;
  myEntryOrders: Array<Maybe<OrderType>>;
  myEvents: Array<Maybe<EventType>>;
  myFollows: Array<Maybe<GroupType>>;
  myGroups: Array<Maybe<GroupType>>;
  notifications?: Maybe<Notifications>;
  options?: Maybe<Array<OptionType>>;
  roomCalendars: Array<Maybe<RoomCalendarType>>;
  rooms?: Maybe<Array<Maybe<RoomType>>>;
};


export type QueryEventArgs = {
  id: Scalars['ID'];
};


export type QueryEventsArgs = {
  page?: Scalars['Int'];
  perPage?: Maybe<Scalars['Int']>;
  search?: Maybe<EventSearch>;
};


export type QueryGroupArgs = {
  id: Scalars['ID'];
};


export type QueryGroupActivitiesArgs = {
  id: Scalars['ID'];
};


export type QueryGroupFeatureEventsArgs = {
  id: Scalars['ID'];
};


export type QueryGroupPastEventsArgs = {
  id: Scalars['ID'];
};


export type QueryGroupsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type QueryNotificationsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};


export type QueryOptionsArgs = {
  search?: Maybe<OptionSearch>;
};


export type QueryRoomCalendarsArgs = {
  search: RoomCalendarSearch;
};

/** Autogenerated input type of RejectEvent */
export type RejectEventInput = {
  id: Scalars['ID'];
  event: EventInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RejectEvent */
export type RejectEventPayload = {
  __typename?: 'RejectEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
};

/** Autogenerated input type of RejectRequest */
export type RejectRequestInput = {
  id: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RejectRequest */
export type RejectRequestPayload = {
  __typename?: 'RejectRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  request?: Maybe<RequestType>;
};

/** Autogenerated input type of RemoveEvent */
export type RemoveEventInput = {
  id: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RemoveEvent */
export type RemoveEventPayload = {
  __typename?: 'RemoveEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
};

/** Autogenerated input type of RemoveEventSchedule */
export type RemoveEventScheduleInput = {
  id: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RemoveEventSchedule */
export type RemoveEventSchedulePayload = {
  __typename?: 'RemoveEventSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
};

/** Autogenerated input type of RemoveGroupActivity */
export type RemoveGroupActivityInput = {
  id: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RemoveGroupActivity */
export type RemoveGroupActivityPayload = {
  __typename?: 'RemoveGroupActivityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  group?: Maybe<GroupType>;
};

/** Autogenerated input type of RemoveGroupComment */
export type RemoveGroupCommentInput = {
  id: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RemoveGroupComment */
export type RemoveGroupCommentPayload = {
  __typename?: 'RemoveGroupCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  comment?: Maybe<GroupCommentType>;
  error?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RemoveRoomCalendar */
export type RemoveRoomCalendarInput = {
  id: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RemoveRoomCalendar */
export type RemoveRoomCalendarPayload = {
  __typename?: 'RemoveRoomCalendarPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type RequestInputType = {
  groupId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RequestPasswordReset */
export type RequestPasswordResetInput = {
  email: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RequestPasswordReset */
export type RequestPasswordResetPayload = {
  __typename?: 'RequestPasswordResetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type RequestType = {
  __typename?: 'RequestType';
  createdAtText?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
  userId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of ResetPassword */
export type ResetPasswordInput = {
  token: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ResetPassword */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RevertEvent */
export type RevertEventInput = {
  id: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RevertEvent */
export type RevertEventPayload = {
  __typename?: 'RevertEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
};

export type RoomCalendarInputType = {
  eventId?: Maybe<Scalars['ID']>;
  roomId?: Maybe<Scalars['ID']>;
  targetDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  calendarType?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
};

export type RoomCalendarSearch = {
  targetDate: Array<Scalars['String']>;
};

export type RoomCalendarType = {
  __typename?: 'RoomCalendarType';
  calendarType?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  endTimeText?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
  eventId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  memo?: Maybe<Scalars['String']>;
  room?: Maybe<RoomType>;
  roomId?: Maybe<Scalars['ID']>;
  startTime?: Maybe<Scalars['String']>;
  startTimeText?: Maybe<Scalars['String']>;
  targetDate?: Maybe<Scalars['Date']>;
  targetDateText?: Maybe<Scalars['String']>;
  targetDateTextFull?: Maybe<Scalars['String']>;
};

export type RoomType = {
  __typename?: 'RoomType';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of SendGroupMail */
export type SendGroupMailInput = {
  groupMail: GroupMailInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of SendGroupMail */
export type SendGroupMailPayload = {
  __typename?: 'SendGroupMailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  groupMail?: Maybe<GroupMailType>;
};

/** Autogenerated input type of Signin */
export type SigninInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of Signin */
export type SigninPayload = {
  __typename?: 'SigninPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
};

/** Autogenerated input type of Signout */
export type SignoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of Signout */
export type SignoutPayload = {
  __typename?: 'SignoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of Signup */
export type SignupInput = {
  userAttributes: UserInputType;
  password: PasswordAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of Signup */
export type SignupPayload = {
  __typename?: 'SignupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
};

/** Autogenerated input type of UnFollow */
export type UnFollowInput = {
  groupId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UnFollow */
export type UnFollowPayload = {
  __typename?: 'UnFollowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  group?: Maybe<GroupType>;
};

/** Autogenerated input type of UpdateAddress */
export type UpdateAddressInput = {
  id: Scalars['ID'];
  attributes?: Maybe<AddressInputType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateAddress */
export type UpdateAddressPayload = {
  __typename?: 'UpdateAddressPayload';
  address?: Maybe<AddressType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateBank */
export type UpdateBankInput = {
  bank: BankInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateBank */
export type UpdateBankPayload = {
  __typename?: 'UpdateBankPayload';
  bank?: Maybe<BankType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateEvent */
export type UpdateEventInput = {
  id: Scalars['ID'];
  event?: Maybe<EventInputType>;
  file?: Maybe<Scalars['File']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateEventOption */
export type UpdateEventOptionInput = {
  id: Scalars['ID'];
  eventOption: EventOptionInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateEventOption */
export type UpdateEventOptionPayload = {
  __typename?: 'UpdateEventOptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  eventOption?: Maybe<EventOptionType>;
};

/** Autogenerated return type of UpdateEvent */
export type UpdateEventPayload = {
  __typename?: 'UpdateEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
};

/** Autogenerated input type of UpdateEventSchedule */
export type UpdateEventScheduleInput = {
  id: Scalars['ID'];
  eventSchedule: EventScheduleInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateEventSchedule */
export type UpdateEventSchedulePayload = {
  __typename?: 'UpdateEventSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
};

/** Autogenerated input type of UpdateGroupActivity */
export type UpdateGroupActivityInput = {
  id: Scalars['ID'];
  attributes: GroupActivityAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateGroupActivity */
export type UpdateGroupActivityPayload = {
  __typename?: 'UpdateGroupActivityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  groupActivity?: Maybe<GroupActivityType>;
};

/** Autogenerated input type of UpdateGroupComment */
export type UpdateGroupCommentInput = {
  id: Scalars['ID'];
  attributes: CommentInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateGroupComment */
export type UpdateGroupCommentPayload = {
  __typename?: 'UpdateGroupCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  comment?: Maybe<GroupCommentType>;
  error?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateGroup */
export type UpdateGroupInput = {
  id: Scalars['ID'];
  group?: Maybe<GroupInputType>;
  file?: Maybe<Scalars['File']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateGroup */
export type UpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  group?: Maybe<GroupType>;
};

/** Autogenerated input type of UpdateGroupUser */
export type UpdateGroupUserInput = {
  id: Scalars['ID'];
  groupUser: GroupUserInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateGroupUser */
export type UpdateGroupUserPayload = {
  __typename?: 'UpdateGroupUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  group?: Maybe<GroupType>;
};

/** Autogenerated input type of UpdateNotification */
export type UpdateNotificationInput = {
  id: Scalars['ID'];
  attributes?: Maybe<NotificationAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateNotification */
export type UpdateNotificationPayload = {
  __typename?: 'UpdateNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  notification?: Maybe<Notification>;
};

/** Autogenerated input type of UpdateOrder */
export type UpdateOrderInput = {
  id: Scalars['ID'];
  order?: Maybe<OrderInputType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateOrder */
export type UpdateOrderPayload = {
  __typename?: 'UpdateOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  order?: Maybe<OrderType>;
};

/** Autogenerated input type of UpdatePassword */
export type UpdatePasswordInput = {
  id: Scalars['ID'];
  attributes?: Maybe<UserInputType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdatePassword */
export type UpdatePasswordPayload = {
  __typename?: 'UpdatePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
};

/** Autogenerated input type of UpdatePayjpCustomer */
export type UpdatePayjpCustomerInput = {
  id: Scalars['ID'];
  attributes: PayjpCustomerAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdatePayjpCustomer */
export type UpdatePayjpCustomerPayload = {
  __typename?: 'UpdatePayjpCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  payjpCustomer?: Maybe<PayjpCustomerType>;
};

/** Autogenerated input type of UpdatePayment */
export type UpdatePaymentInput = {
  id: Scalars['ID'];
  attributes: PaymentInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdatePayment */
export type UpdatePaymentPayload = {
  __typename?: 'UpdatePaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  payment?: Maybe<PaymentType>;
};

/** Autogenerated input type of UpdateRequest */
export type UpdateRequestInput = {
  id: Scalars['ID'];
  request: RequestInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateRequest */
export type UpdateRequestPayload = {
  __typename?: 'UpdateRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  request?: Maybe<RequestType>;
};

/** Autogenerated input type of UpdateRoomCalendar */
export type UpdateRoomCalendarInput = {
  id: Scalars['ID'];
  attributes: RoomCalendarInputType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateRoomCalendar */
export type UpdateRoomCalendarPayload = {
  __typename?: 'UpdateRoomCalendarPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  roomCalendar?: Maybe<RoomCalendarType>;
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  id: Scalars['ID'];
  user?: Maybe<UserInputType>;
  file?: Maybe<Scalars['File']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateUser */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
};

export type UserInputType = {
  email?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  currentPassword?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  passwordConfirmation?: Maybe<Scalars['String']>;
};

export type UserType = {
  __typename?: 'UserType';
  address?: Maybe<AddressType>;
  avatar?: Maybe<Scalars['String']>;
  bank?: Maybe<BankType>;
  createdAtText?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  payjpCustomer?: Maybe<PayjpCustomerType>;
};

export type AddressFragmentFragment = (
  { __typename?: 'AddressType' }
  & Pick<AddressType, 'id' | 'orderId' | 'userId' | 'industryTypeId' | 'firstName' | 'lastName' | 'gender' | 'genderText' | 'birthdayYear' | 'birthdayMonth' | 'birthdayDay' | 'tel' | 'zipcode' | 'address1' | 'address2' | 'companyName' | 'companyNameKana' | 'companyBranchName' | 'companyPosition' | 'companyTel' | 'companyFax'>
);

export type BankFragmentFragment = (
  { __typename?: 'BankType' }
  & Pick<BankType, 'id' | 'userId' | 'name' | 'branch' | 'accountType' | 'accountTypeText' | 'accountNumber' | 'accountName'>
);

export type ContactFragmentFragment = (
  { __typename?: 'Contact' }
  & Pick<Contact, 'id' | 'firstName' | 'lastName' | 'email' | 'tel' | 'message'>
);

export type EventFragmentFragment = (
  { __typename?: 'EventType' }
  & Pick<EventType, 'id' | 'groupId' | 'title' | 'description' | 'eventDate' | 'eventDatetimeText' | 'eventDateText' | 'eventDateWday' | 'startTimeText' | 'mainImage' | 'mainImageUrl' | 'eventStatus' | 'eventStatusText' | 'paymentStatus' | 'paymentStatusText' | 'akerunStatus' | 'akerunStatusText' | 'locationType' | 'locationTypeText' | 'location' | 'ticketQuantity' | 'ticketAmount' | 'isFree' | 'dueDate' | 'dueDateText' | 'dueTime' | 'dueTimeText' | 'address' | 'organizer' | 'informationEmail' | 'informationTel' | 'acmPrice' | 'taxAcmPrice' | 'guestCount' | 'cancelDate' | 'cancelDateText' | 'cancelTime' | 'cancelTimeText' | 'canCancel' | 'onShowpage' | 'isShowEventList' | 'eventType' | 'eventTypeText' | 'chargeId' | 'ticketPaymentMethod' | 'ticketPaymentMethodText' | 'ownerPaymentStatus' | 'ownerPaymentStatusText' | 'isReceipt' | 'receiptName' | 'ownerPaymentDate' | 'receiptStatus' | 'receiptStatusText' | 'orderCount' | 'totalSalesPrice' | 'totalFee' | 'totalPaymentPrice'>
);

export type EventOptionFragmentFragment = (
  { __typename?: 'EventOptionType' }
  & Pick<EventOptionType, 'id' | 'eventId' | 'optionId' | 'isApply'>
);

export type EventScheduleFragmentFragment = (
  { __typename?: 'EventScheduleType' }
  & Pick<EventScheduleType, 'id' | 'eventId' | 'eventDate' | 'eventDateText' | 'eventDateTextFull' | 'eventDateWday' | 'startTime' | 'startTimeText' | 'endTime' | 'endTimeText'>
);

export type GroupFragmentFragment = (
  { __typename?: 'GroupType' }
  & Pick<GroupType, 'id' | 'name' | 'mainImage' | 'mainImageUrl' | 'content' | 'location' | 'owner' | 'isAdmin' | 'groupAdminCount' | 'groupMemberCount' | 'groupFollowerCount'>
);

export type GroupActivityFragmentFragment = (
  { __typename?: 'GroupActivityType' }
  & Pick<GroupActivityType, 'id' | 'groupId' | 'userId' | 'title'>
);

export type GroupCommentFragmentFragment = (
  { __typename?: 'GroupCommentType' }
  & Pick<GroupCommentType, 'id' | 'groupActivityId' | 'userId' | 'message' | 'createdAtText' | 'isEdit' | 'isRemove'>
);

export type IndustryTypeFragmentFragment = (
  { __typename?: 'IndustryTypeType' }
  & Pick<IndustryTypeType, 'id' | 'name'>
);

export type NotificationFragmentFragment = (
  { __typename?: 'Notification' }
  & Pick<Notification, 'id' | 'status' | 'statusText' | 'message' | 'startDate' | 'endDate' | 'startDateText' | 'endDateText'>
);

export type OptionFragmentFragment = (
  { __typename?: 'OptionType' }
  & Pick<OptionType, 'id' | 'optionType' | 'name' | 'description'>
);

export type OrderFragmentFragment = (
  { __typename?: 'OrderType' }
  & Pick<OrderType, 'id' | 'workflowState' | 'workflowStateText' | 'totalPrice' | 'completedAtText' | 'chargeId' | 'paymentState' | 'paymentStateText'>
);

export type PaginationFragmentFragment = (
  { __typename?: 'Pagination' }
  & Pick<Pagination, 'resultsCount' | 'totalCount' | 'totalPages' | 'currentPage' | 'nextPage' | 'previousPage' | 'hasNextPage' | 'hasPreviousPage'>
);

export type PayjpCardFragmentFragment = (
  { __typename?: 'PayjpCardType' }
  & Pick<PayjpCardType, 'id' | 'cardId' | 'customerId' | 'created' | 'name' | 'last4' | 'expMonth' | 'expYear'>
);

export type PayjpCustomerFragmentFragment = (
  { __typename?: 'PayjpCustomerType' }
  & Pick<PayjpCustomerType, 'id' | 'userId' | 'customerId'>
);

export type PaymentFragmentFragment = (
  { __typename?: 'PaymentType' }
  & Pick<PaymentType, 'id' | 'eventId' | 'paymentMethod'>
);

export type RoomCalendarFragmentFragment = (
  { __typename?: 'RoomCalendarType' }
  & Pick<RoomCalendarType, 'id' | 'roomId' | 'eventId' | 'targetDate' | 'startTime' | 'startTimeText' | 'endTime' | 'endTimeText' | 'targetDateText' | 'calendarType' | 'memo'>
);

export type UserFragmentFragment = (
  { __typename?: 'UserType' }
  & Pick<UserType, 'id' | 'email' | 'avatar' | 'fullName'>
);

export type ChangePasswordMutationVariables = Exact<{
  password: PasswordAttributes;
}>;


export type ChangePasswordMutation = (
  { __typename?: 'Mutation' }
  & { changePassword: (
    { __typename?: 'ChangePasswordPayload' }
    & Pick<ChangePasswordPayload, 'error'>
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & UserFragmentFragment
    )> }
  ) }
);

export type ConfirmMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ConfirmMutation = (
  { __typename?: 'Mutation' }
  & { confirm?: Maybe<(
    { __typename?: 'ConfirmPayload' }
    & Pick<ConfirmPayload, 'error'>
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & UserFragmentFragment
    )> }
  )> }
);

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestPasswordResetMutation = (
  { __typename?: 'Mutation' }
  & { requestPasswordReset?: Maybe<(
    { __typename?: 'RequestPasswordResetPayload' }
    & Pick<RequestPasswordResetPayload, 'error'>
  )> }
);

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & { resetPassword?: Maybe<(
    { __typename?: 'ResetPasswordPayload' }
    & Pick<ResetPasswordPayload, 'error'>
  )> }
);

export type SigninMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type SigninMutation = (
  { __typename?: 'Mutation' }
  & { signin: (
    { __typename?: 'SigninPayload' }
    & Pick<SigninPayload, 'error'>
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & UserFragmentFragment
    )> }
  ) }
);

export type SignoutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignoutMutation = (
  { __typename?: 'Mutation' }
  & { signout: (
    { __typename?: 'SignoutPayload' }
    & Pick<SignoutPayload, 'result'>
  ) }
);

export type SignupMutationVariables = Exact<{
  user: UserInputType;
  password: PasswordAttributes;
}>;


export type SignupMutation = (
  { __typename?: 'Mutation' }
  & { signup: (
    { __typename?: 'SignupPayload' }
    & Pick<SignupPayload, 'error'>
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & Pick<UserType, 'id'>
    )> }
  ) }
);

export type UpdateBankMutationVariables = Exact<{
  bank: BankInputType;
}>;


export type UpdateBankMutation = (
  { __typename?: 'Mutation' }
  & { updateBank?: Maybe<(
    { __typename?: 'UpdateBankPayload' }
    & { bank?: Maybe<(
      { __typename?: 'BankType' }
      & BankFragmentFragment
    )> }
  )> }
);

export type AddressMutationVariables = Exact<{
  id: Scalars['ID'];
  address: AddressInputType;
}>;


export type AddressMutation = (
  { __typename?: 'Mutation' }
  & { address?: Maybe<(
    { __typename?: 'AddressPayload' }
    & { order?: Maybe<(
      { __typename?: 'OrderType' }
      & Pick<OrderType, 'id'>
      & { user?: Maybe<(
        { __typename?: 'UserType' }
        & { address?: Maybe<(
          { __typename?: 'AddressType' }
          & { industryType?: Maybe<(
            { __typename?: 'IndustryTypeType' }
            & Pick<IndustryTypeType, 'id'>
          )> }
          & AddressFragmentFragment
        )> }
        & UserFragmentFragment
      )> }
    )> }
  )> }
);

export type CreatePayjpCustomerMutationVariables = Exact<{
  attributes: PayjpCustomerAttributes;
}>;


export type CreatePayjpCustomerMutation = (
  { __typename?: 'Mutation' }
  & { createPayjpCustomer?: Maybe<(
    { __typename?: 'CreatePayjpCustomerPayload' }
    & { payjpCustomer?: Maybe<(
      { __typename?: 'PayjpCustomerType' }
      & { card?: Maybe<(
        { __typename?: 'PayjpCardType' }
        & PayjpCardFragmentFragment
      )> }
      & PayjpCustomerFragmentFragment
    )> }
  )> }
);

export type OrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrderMutation = (
  { __typename?: 'Mutation' }
  & { order?: Maybe<(
    { __typename?: 'OrderPayload' }
    & Pick<OrderPayload, 'error'>
    & { order?: Maybe<(
      { __typename?: 'OrderType' }
      & OrderFragmentFragment
    )> }
  )> }
);

export type PaymentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PaymentMutation = (
  { __typename?: 'Mutation' }
  & { payment?: Maybe<(
    { __typename?: 'PaymentPayload' }
    & { order?: Maybe<(
      { __typename?: 'OrderType' }
      & OrderFragmentFragment
    )> }
  )> }
);

export type UpdatePayjpCustomerMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: PayjpCustomerAttributes;
}>;


export type UpdatePayjpCustomerMutation = (
  { __typename?: 'Mutation' }
  & { updatePayjpCustomer?: Maybe<(
    { __typename?: 'UpdatePayjpCustomerPayload' }
    & { payjpCustomer?: Maybe<(
      { __typename?: 'PayjpCustomerType' }
      & { card?: Maybe<(
        { __typename?: 'PayjpCardType' }
        & PayjpCardFragmentFragment
      )> }
      & PayjpCustomerFragmentFragment
    )> }
  )> }
);

export type CreateContactMutationVariables = Exact<{
  attributes: ContactAttributes;
}>;


export type CreateContactMutation = (
  { __typename?: 'Mutation' }
  & { createContact?: Maybe<(
    { __typename?: 'CreateContactPayload' }
    & { contact?: Maybe<(
      { __typename?: 'Contact' }
      & ContactFragmentFragment
    )> }
  )> }
);

export type AcceptEventMutationVariables = Exact<{
  id: Scalars['ID'];
  event: EventInputType;
}>;


export type AcceptEventMutation = (
  { __typename?: 'Mutation' }
  & { acceptEvent?: Maybe<(
    { __typename?: 'AcceptEventPayload' }
    & Pick<AcceptEventPayload, 'error'>
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & EventFragmentFragment
    )> }
  )> }
);

export type ApplyCouponToEventMutationVariables = Exact<{
  id: Scalars['ID'];
  coupon: Scalars['String'];
}>;


export type ApplyCouponToEventMutation = (
  { __typename?: 'Mutation' }
  & { applyCouponToEvent?: Maybe<(
    { __typename?: 'ApplyCouponToEventPayload' }
    & Pick<ApplyCouponToEventPayload, 'error'>
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & EventFragmentFragment
    )> }
  )> }
);

export type ApplyEventMutationVariables = Exact<{
  id: Scalars['ID'];
  event: EventInputType;
}>;


export type ApplyEventMutation = (
  { __typename?: 'Mutation' }
  & { applyEvent?: Maybe<(
    { __typename?: 'ApplyEventPayload' }
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & EventFragmentFragment
    )> }
  )> }
);

export type CreateEventMutationVariables = Exact<{
  event: EventInputType;
}>;


export type CreateEventMutation = (
  { __typename?: 'Mutation' }
  & { createEvent?: Maybe<(
    { __typename?: 'CreateEventPayload' }
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & EventFragmentFragment
    )> }
  )> }
);

export type RejectEventMutationVariables = Exact<{
  id: Scalars['ID'];
  event: EventInputType;
}>;


export type RejectEventMutation = (
  { __typename?: 'Mutation' }
  & { rejectEvent?: Maybe<(
    { __typename?: 'RejectEventPayload' }
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & EventFragmentFragment
    )> }
  )> }
);

export type RemoveEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveEventMutation = (
  { __typename?: 'Mutation' }
  & { removeEvent?: Maybe<(
    { __typename?: 'RemoveEventPayload' }
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & EventFragmentFragment
    )> }
  )> }
);

export type RevertEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RevertEventMutation = (
  { __typename?: 'Mutation' }
  & { revertEvent?: Maybe<(
    { __typename?: 'RevertEventPayload' }
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & EventFragmentFragment
    )> }
  )> }
);

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['ID'];
  event?: Maybe<EventInputType>;
  file?: Maybe<Scalars['File']>;
}>;


export type UpdateEventMutation = (
  { __typename?: 'Mutation' }
  & { updateEvent?: Maybe<(
    { __typename?: 'UpdateEventPayload' }
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & EventFragmentFragment
    )> }
  )> }
);

export type UpdateEventOptionMutationVariables = Exact<{
  id: Scalars['ID'];
  eventOption: EventOptionInputType;
}>;


export type UpdateEventOptionMutation = (
  { __typename?: 'Mutation' }
  & { updateEventOption?: Maybe<(
    { __typename?: 'UpdateEventOptionPayload' }
    & { eventOption?: Maybe<(
      { __typename?: 'EventOptionType' }
      & EventOptionFragmentFragment
    )> }
  )> }
);

export type CreateEventScheduleMutationVariables = Exact<{
  eventSchedule: EventScheduleInputType;
}>;


export type CreateEventScheduleMutation = (
  { __typename?: 'Mutation' }
  & { createEventSchedule?: Maybe<(
    { __typename?: 'CreateEventSchedulePayload' }
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & { eventSchedules?: Maybe<Array<Maybe<(
        { __typename?: 'EventScheduleType' }
        & EventScheduleFragmentFragment
      )>>> }
      & EventFragmentFragment
    )> }
  )> }
);

export type RemoveEventScheduleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveEventScheduleMutation = (
  { __typename?: 'Mutation' }
  & { removeEventSchedule?: Maybe<(
    { __typename?: 'RemoveEventSchedulePayload' }
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & { eventSchedules?: Maybe<Array<Maybe<(
        { __typename?: 'EventScheduleType' }
        & EventScheduleFragmentFragment
      )>>> }
      & EventFragmentFragment
    )> }
  )> }
);

export type UpdateEventScheduleMutationVariables = Exact<{
  id: Scalars['ID'];
  eventSchedule: EventScheduleInputType;
}>;


export type UpdateEventScheduleMutation = (
  { __typename?: 'Mutation' }
  & { updateEventSchedule?: Maybe<(
    { __typename?: 'UpdateEventSchedulePayload' }
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & { eventSchedules?: Maybe<Array<Maybe<(
        { __typename?: 'EventScheduleType' }
        & EventScheduleFragmentFragment
      )>>> }
      & EventFragmentFragment
    )> }
  )> }
);

export type AcceptRequestMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AcceptRequestMutation = (
  { __typename?: 'Mutation' }
  & { acceptRequest?: Maybe<(
    { __typename?: 'AcceptRequestPayload' }
    & { request?: Maybe<(
      { __typename?: 'RequestType' }
      & Pick<RequestType, 'id' | 'groupId' | 'userId' | 'status'>
    )> }
  )> }
);

export type AddGroupActivityMutationVariables = Exact<{
  attributes: GroupActivityAttributes;
}>;


export type AddGroupActivityMutation = (
  { __typename?: 'Mutation' }
  & { addGroupActivity?: Maybe<(
    { __typename?: 'AddGroupActivityPayload' }
    & { group?: Maybe<(
      { __typename?: 'GroupType' }
      & Pick<GroupType, 'id' | 'isAdmin' | 'name'>
      & { activities?: Maybe<Array<Maybe<(
        { __typename?: 'GroupActivityType' }
        & Pick<GroupActivityType, 'id' | 'groupId' | 'userId' | 'title'>
        & { comments?: Maybe<Array<Maybe<(
          { __typename?: 'GroupCommentType' }
          & Pick<GroupCommentType, 'id' | 'groupActivityId' | 'userId' | 'message' | 'createdAtText' | 'isEdit' | 'isRemove'>
          & { user?: Maybe<(
            { __typename?: 'UserType' }
            & Pick<UserType, 'id' | 'fullName'>
          )> }
        )>>> }
      )>>> }
    )> }
  )> }
);

export type AddGroupCommentMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: CommentInputType;
}>;


export type AddGroupCommentMutation = (
  { __typename?: 'Mutation' }
  & { addGroupComment?: Maybe<(
    { __typename?: 'AddGroupCommentPayload' }
    & { comment?: Maybe<(
      { __typename?: 'GroupCommentType' }
      & Pick<GroupCommentType, 'id' | 'groupActivityId' | 'userId' | 'message' | 'createdAtText' | 'isEdit' | 'isRemove'>
      & { user?: Maybe<(
        { __typename?: 'UserType' }
        & Pick<UserType, 'id' | 'fullName'>
      )> }
    )> }
  )> }
);

export type CreateGroupMutationVariables = Exact<{
  group: GroupInputType;
}>;


export type CreateGroupMutation = (
  { __typename?: 'Mutation' }
  & { createGroup?: Maybe<(
    { __typename?: 'CreateGroupPayload' }
    & { group?: Maybe<(
      { __typename?: 'GroupType' }
      & GroupFragmentFragment
    )> }
  )> }
);

export type CreateRequestMutationVariables = Exact<{
  request: RequestInputType;
}>;


export type CreateRequestMutation = (
  { __typename?: 'Mutation' }
  & { createRequest?: Maybe<(
    { __typename?: 'CreateRequestPayload' }
    & { group?: Maybe<(
      { __typename?: 'GroupType' }
      & GroupFragmentFragment
    )> }
  )> }
);

export type DestroyGroupUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyGroupUserMutation = (
  { __typename?: 'Mutation' }
  & { destroyGroupUser?: Maybe<(
    { __typename?: 'DestroyGroupUserPayload' }
    & { group?: Maybe<(
      { __typename?: 'GroupType' }
      & Pick<GroupType, 'id'>
      & { groupAdmins?: Maybe<Array<Maybe<(
        { __typename?: 'GroupUserType' }
        & Pick<GroupUserType, 'id'>
        & { user?: Maybe<(
          { __typename?: 'UserType' }
          & Pick<UserType, 'id' | 'email' | 'fullName'>
        )> }
      )>>>, groupMembers?: Maybe<Array<Maybe<(
        { __typename?: 'GroupUserType' }
        & Pick<GroupUserType, 'id'>
        & { user?: Maybe<(
          { __typename?: 'UserType' }
          & Pick<UserType, 'id' | 'email' | 'fullName'>
        )> }
      )>>> }
    )> }
  )> }
);

export type RejectRequestMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RejectRequestMutation = (
  { __typename?: 'Mutation' }
  & { rejectRequest?: Maybe<(
    { __typename?: 'RejectRequestPayload' }
    & { request?: Maybe<(
      { __typename?: 'RequestType' }
      & Pick<RequestType, 'id' | 'groupId' | 'userId' | 'status'>
    )> }
  )> }
);

export type RemoveGroupActivityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveGroupActivityMutation = (
  { __typename?: 'Mutation' }
  & { removeGroupActivity?: Maybe<(
    { __typename?: 'RemoveGroupActivityPayload' }
    & { group?: Maybe<(
      { __typename?: 'GroupType' }
      & Pick<GroupType, 'id' | 'isAdmin' | 'name'>
      & { activities?: Maybe<Array<Maybe<(
        { __typename?: 'GroupActivityType' }
        & Pick<GroupActivityType, 'id' | 'groupId' | 'userId' | 'title'>
        & { comments?: Maybe<Array<Maybe<(
          { __typename?: 'GroupCommentType' }
          & Pick<GroupCommentType, 'id' | 'groupActivityId' | 'userId' | 'message' | 'createdAtText' | 'isEdit' | 'isRemove'>
          & { user?: Maybe<(
            { __typename?: 'UserType' }
            & Pick<UserType, 'id' | 'fullName'>
          )> }
        )>>> }
      )>>> }
    )> }
  )> }
);

export type RemoveGroupCommentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveGroupCommentMutation = (
  { __typename?: 'Mutation' }
  & { removeGroupComment?: Maybe<(
    { __typename?: 'RemoveGroupCommentPayload' }
    & { comment?: Maybe<(
      { __typename?: 'GroupCommentType' }
      & Pick<GroupCommentType, 'id' | 'groupActivityId' | 'userId' | 'message' | 'createdAtText' | 'isEdit' | 'isRemove'>
      & { user?: Maybe<(
        { __typename?: 'UserType' }
        & Pick<UserType, 'id' | 'fullName'>
      )> }
    )> }
  )> }
);

export type SendGroupMailMutationVariables = Exact<{
  groupMail: GroupMailInputType;
}>;


export type SendGroupMailMutation = (
  { __typename?: 'Mutation' }
  & { sendGroupMail?: Maybe<(
    { __typename?: 'SendGroupMailPayload' }
    & { groupMail?: Maybe<(
      { __typename?: 'GroupMailType' }
      & Pick<GroupMailType, 'id'>
    )> }
  )> }
);

export type UpdateGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  group: GroupInputType;
  file?: Maybe<Scalars['File']>;
}>;


export type UpdateGroupMutation = (
  { __typename?: 'Mutation' }
  & { updateGroup?: Maybe<(
    { __typename?: 'UpdateGroupPayload' }
    & { group?: Maybe<(
      { __typename?: 'GroupType' }
      & GroupFragmentFragment
    )> }
  )> }
);

export type UpdateGroupActivityMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: GroupActivityAttributes;
}>;


export type UpdateGroupActivityMutation = (
  { __typename?: 'Mutation' }
  & { updateGroupActivity?: Maybe<(
    { __typename?: 'UpdateGroupActivityPayload' }
    & { groupActivity?: Maybe<(
      { __typename?: 'GroupActivityType' }
      & Pick<GroupActivityType, 'id' | 'title'>
    )> }
  )> }
);

export type UpdateGroupCommentMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: CommentInputType;
}>;


export type UpdateGroupCommentMutation = (
  { __typename?: 'Mutation' }
  & { updateGroupComment?: Maybe<(
    { __typename?: 'UpdateGroupCommentPayload' }
    & { comment?: Maybe<(
      { __typename?: 'GroupCommentType' }
      & Pick<GroupCommentType, 'id' | 'message' | 'isEdit' | 'isRemove'>
    )> }
  )> }
);

export type UpdateGroupUserMutationVariables = Exact<{
  id: Scalars['ID'];
  groupUser: GroupUserInputType;
}>;


export type UpdateGroupUserMutation = (
  { __typename?: 'Mutation' }
  & { updateGroupUser?: Maybe<(
    { __typename?: 'UpdateGroupUserPayload' }
    & { group?: Maybe<(
      { __typename?: 'GroupType' }
      & Pick<GroupType, 'id'>
      & { groupAdmins?: Maybe<Array<Maybe<(
        { __typename?: 'GroupUserType' }
        & Pick<GroupUserType, 'id'>
        & { user?: Maybe<(
          { __typename?: 'UserType' }
          & Pick<UserType, 'id' | 'email' | 'fullName'>
        )> }
      )>>>, groupMembers?: Maybe<Array<Maybe<(
        { __typename?: 'GroupUserType' }
        & Pick<GroupUserType, 'id'>
        & { user?: Maybe<(
          { __typename?: 'UserType' }
          & Pick<UserType, 'id' | 'email' | 'fullName'>
        )> }
      )>>> }
    )> }
  )> }
);

export type CreateNotificationMutationVariables = Exact<{
  attributes: NotificationAttributes;
}>;


export type CreateNotificationMutation = (
  { __typename?: 'Mutation' }
  & { createNotification?: Maybe<(
    { __typename?: 'CreateNotificationPayload' }
    & { notification?: Maybe<(
      { __typename?: 'Notification' }
      & NotificationFragmentFragment
    )> }
  )> }
);

export type UpdateNotificationMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: NotificationAttributes;
}>;


export type UpdateNotificationMutation = (
  { __typename?: 'Mutation' }
  & { updateNotification?: Maybe<(
    { __typename?: 'UpdateNotificationPayload' }
    & { notification?: Maybe<(
      { __typename?: 'Notification' }
      & NotificationFragmentFragment
    )> }
  )> }
);

export type CancelOrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelOrderMutation = (
  { __typename?: 'Mutation' }
  & { cancelOrder?: Maybe<(
    { __typename?: 'CancelOrderPayload' }
    & Pick<CancelOrderPayload, 'error'>
    & { order?: Maybe<(
      { __typename?: 'OrderType' }
      & OrderFragmentFragment
    )> }
  )> }
);

export type UpdateOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  order: OrderInputType;
}>;


export type UpdateOrderMutation = (
  { __typename?: 'Mutation' }
  & { updateOrder?: Maybe<(
    { __typename?: 'UpdateOrderPayload' }
    & { order?: Maybe<(
      { __typename?: 'OrderType' }
      & OrderFragmentFragment
    )> }
  )> }
);

export type CreatePaymentMutationVariables = Exact<{
  attributes: PaymentInputType;
}>;


export type CreatePaymentMutation = (
  { __typename?: 'Mutation' }
  & { createPayment?: Maybe<(
    { __typename?: 'CreatePaymentPayload' }
    & { payment?: Maybe<(
      { __typename?: 'PaymentType' }
      & PaymentFragmentFragment
    )> }
  )> }
);

export type UpdatePaymentMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: PaymentInputType;
}>;


export type UpdatePaymentMutation = (
  { __typename?: 'Mutation' }
  & { updatePayment?: Maybe<(
    { __typename?: 'UpdatePaymentPayload' }
    & { payment?: Maybe<(
      { __typename?: 'PaymentType' }
      & PaymentFragmentFragment
    )> }
  )> }
);

export type CreateRoomCalendarMutationVariables = Exact<{
  roomCalendar: RoomCalendarInputType;
}>;


export type CreateRoomCalendarMutation = (
  { __typename?: 'Mutation' }
  & { createRoomCalendar?: Maybe<(
    { __typename?: 'CreateRoomCalendarPayload' }
    & Pick<CreateRoomCalendarPayload, 'error'>
    & { roomCalendar?: Maybe<(
      { __typename?: 'RoomCalendarType' }
      & { event?: Maybe<(
        { __typename?: 'EventType' }
        & EventFragmentFragment
      )> }
      & RoomCalendarFragmentFragment
    )> }
  )> }
);

export type RemoveRoomCalendarMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveRoomCalendarMutation = (
  { __typename?: 'Mutation' }
  & { removeRoomCalendar?: Maybe<(
    { __typename?: 'RemoveRoomCalendarPayload' }
    & Pick<RemoveRoomCalendarPayload, 'id' | 'error'>
  )> }
);

export type UpdateRoomCalendarMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: RoomCalendarInputType;
}>;


export type UpdateRoomCalendarMutation = (
  { __typename?: 'Mutation' }
  & { updateRoomCalendar?: Maybe<(
    { __typename?: 'UpdateRoomCalendarPayload' }
    & { roomCalendar?: Maybe<(
      { __typename?: 'RoomCalendarType' }
      & RoomCalendarFragmentFragment
    )> }
  )> }
);

export type UpdateAddressMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes?: Maybe<AddressInputType>;
}>;


export type UpdateAddressMutation = (
  { __typename?: 'Mutation' }
  & { updateAddress?: Maybe<(
    { __typename?: 'UpdateAddressPayload' }
    & { address?: Maybe<(
      { __typename?: 'AddressType' }
      & AddressFragmentFragment
    )> }
  )> }
);

export type UpdatePasswordMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes?: Maybe<UserInputType>;
}>;


export type UpdatePasswordMutation = (
  { __typename?: 'Mutation' }
  & { updatePassword?: Maybe<(
    { __typename?: 'UpdatePasswordPayload' }
    & Pick<UpdatePasswordPayload, 'error'>
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & UserFragmentFragment
    )> }
  )> }
);

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  file?: Maybe<Scalars['File']>;
  user?: Maybe<UserInputType>;
}>;


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'UpdateUserPayload' }
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & UserFragmentFragment
    )> }
  )> }
);

export type BankQueryVariables = Exact<{ [key: string]: never; }>;


export type BankQuery = (
  { __typename?: 'Query' }
  & { bank?: Maybe<(
    { __typename?: 'BankType' }
    & BankFragmentFragment
  )> }
);

export type CurrentOrderQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentOrderQuery = (
  { __typename?: 'Query' }
  & { currentOrder?: Maybe<(
    { __typename?: 'OrderType' }
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & { eventSchedules?: Maybe<Array<Maybe<(
        { __typename?: 'EventScheduleType' }
        & EventScheduleFragmentFragment
      )>>> }
      & EventFragmentFragment
    )> }
    & OrderFragmentFragment
  )> }
);

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = (
  { __typename?: 'Query' }
  & { currentUser?: Maybe<(
    { __typename?: 'UserType' }
    & { payjpCustomer?: Maybe<(
      { __typename?: 'PayjpCustomerType' }
      & Pick<PayjpCustomerType, 'id'>
      & { card?: Maybe<(
        { __typename?: 'PayjpCardType' }
        & Pick<PayjpCardType, 'id' | 'cardId' | 'customerId' | 'created' | 'name' | 'last4' | 'expMonth' | 'expYear'>
      )> }
    )>, address?: Maybe<(
      { __typename?: 'AddressType' }
      & { industryType?: Maybe<(
        { __typename?: 'IndustryTypeType' }
        & Pick<IndustryTypeType, 'id'>
      )> }
      & AddressFragmentFragment
    )> }
    & UserFragmentFragment
  )> }
);

export type EventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventQuery = (
  { __typename?: 'Query' }
  & { myEvents: Array<Maybe<(
    { __typename?: 'EventType' }
    & EventFragmentFragment
  )>>, event?: Maybe<(
    { __typename?: 'EventType' }
    & Pick<EventType, 'overFirstEventDate' | 'groupId'>
    & { eventSchedules?: Maybe<Array<Maybe<(
      { __typename?: 'EventScheduleType' }
      & EventScheduleFragmentFragment
    )>>>, acceptedOrders?: Maybe<Array<Maybe<(
      { __typename?: 'OrderType' }
      & { user?: Maybe<(
        { __typename?: 'UserType' }
        & { payjpCustomer?: Maybe<(
          { __typename?: 'PayjpCustomerType' }
          & Pick<PayjpCustomerType, 'id' | 'userId' | 'customerId'>
        )>, address?: Maybe<(
          { __typename?: 'AddressType' }
          & Pick<AddressType, 'id' | 'userId' | 'tel'>
        )> }
        & UserFragmentFragment
      )> }
      & OrderFragmentFragment
    )>>>, user?: Maybe<(
      { __typename?: 'UserType' }
      & Pick<UserType, 'id'>
      & { payjpCustomer?: Maybe<(
        { __typename?: 'PayjpCustomerType' }
        & Pick<PayjpCustomerType, 'id' | 'userId' | 'customerId'>
      )>, address?: Maybe<(
        { __typename?: 'AddressType' }
        & { industryType?: Maybe<(
          { __typename?: 'IndustryTypeType' }
          & Pick<IndustryTypeType, 'id' | 'name'>
        )> }
        & AddressFragmentFragment
      )>, bank?: Maybe<(
        { __typename?: 'BankType' }
        & BankFragmentFragment
      )> }
      & UserFragmentFragment
    )>, roomCalendars?: Maybe<Array<Maybe<(
      { __typename?: 'RoomCalendarType' }
      & { room?: Maybe<(
        { __typename?: 'RoomType' }
        & Pick<RoomType, 'id' | 'name'>
      )> }
      & RoomCalendarFragmentFragment
    )>>>, eventOptions?: Maybe<Array<Maybe<(
      { __typename?: 'EventOptionType' }
      & { option?: Maybe<(
        { __typename?: 'OptionType' }
        & Pick<OptionType, 'id' | 'name' | 'optionType' | 'description'>
      )> }
      & EventOptionFragmentFragment
    )>>>, payment?: Maybe<(
      { __typename?: 'PaymentType' }
      & { payjpCard?: Maybe<(
        { __typename?: 'PayjpCardType' }
        & Pick<PayjpCardType, 'id' | 'cardId' | 'last4' | 'expMonth' | 'expYear'>
      )> }
      & PaymentFragmentFragment
    )>, group?: Maybe<(
      { __typename?: 'GroupType' }
      & Pick<GroupType, 'id' | 'name' | 'mainImageUrl'>
      & { followers?: Maybe<Array<Maybe<(
        { __typename?: 'FollowType' }
        & Pick<FollowType, 'id' | 'groupId' | 'userId'>
      )>>> }
    )> }
    & EventFragmentFragment
  )>, options?: Maybe<Array<(
    { __typename?: 'OptionType' }
    & Pick<OptionType, 'id' | 'name' | 'optionType' | 'description'>
  )>>, rooms?: Maybe<Array<Maybe<(
    { __typename?: 'RoomType' }
    & Pick<RoomType, 'id' | 'name'>
  )>>> }
);

export type EventsQueryVariables = Exact<{
  page: Scalars['Int'];
  search?: Maybe<EventSearch>;
}>;


export type EventsQuery = (
  { __typename?: 'Query' }
  & { events?: Maybe<(
    { __typename?: 'EventsType' }
    & { events?: Maybe<Array<Maybe<(
      { __typename?: 'EventType' }
      & { eventSchedules?: Maybe<Array<Maybe<(
        { __typename?: 'EventScheduleType' }
        & EventScheduleFragmentFragment
      )>>>, user?: Maybe<(
        { __typename?: 'UserType' }
        & UserFragmentFragment
      )>, payment?: Maybe<(
        { __typename?: 'PaymentType' }
        & PaymentFragmentFragment
      )> }
      & EventFragmentFragment
    )>>>, pagination?: Maybe<(
      { __typename?: 'Pagination' }
      & PaginationFragmentFragment
    )> }
  )> }
);

export type MyEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyEventsQuery = (
  { __typename?: 'Query' }
  & { myEvents: Array<Maybe<(
    { __typename?: 'EventType' }
    & { eventSchedules?: Maybe<Array<Maybe<(
      { __typename?: 'EventScheduleType' }
      & EventScheduleFragmentFragment
    )>>>, group?: Maybe<(
      { __typename?: 'GroupType' }
      & Pick<GroupType, 'id' | 'name'>
    )> }
    & EventFragmentFragment
  )>> }
);

export type FollowMutationVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type FollowMutation = (
  { __typename?: 'Mutation' }
  & { follow?: Maybe<(
    { __typename?: 'FollowPayload' }
    & { group?: Maybe<(
      { __typename?: 'GroupType' }
      & Pick<GroupType, 'id'>
      & { followers?: Maybe<Array<Maybe<(
        { __typename?: 'FollowType' }
        & Pick<FollowType, 'id' | 'userId' | 'groupId'>
        & { user?: Maybe<(
          { __typename?: 'UserType' }
          & Pick<UserType, 'id' | 'fullName'>
        )> }
      )>>> }
    )> }
  )> }
);

export type GroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GroupQuery = (
  { __typename?: 'Query' }
  & { myGroups: Array<Maybe<(
    { __typename?: 'GroupType' }
    & GroupFragmentFragment
  )>>, group?: Maybe<(
    { __typename?: 'GroupType' }
    & Pick<GroupType, 'myRequestStatus'>
    & { users?: Maybe<Array<Maybe<(
      { __typename?: 'UserType' }
      & Pick<UserType, 'id' | 'email' | 'fullName'>
    )>>>, requests?: Maybe<Array<Maybe<(
      { __typename?: 'RequestType' }
      & Pick<RequestType, 'id' | 'groupId' | 'userId' | 'status' | 'createdAtText'>
      & { user?: Maybe<(
        { __typename?: 'UserType' }
        & UserFragmentFragment
      )> }
    )>>>, groupAdmins?: Maybe<Array<Maybe<(
      { __typename?: 'GroupUserType' }
      & Pick<GroupUserType, 'id'>
      & { user?: Maybe<(
        { __typename?: 'UserType' }
        & Pick<UserType, 'id' | 'email' | 'fullName'>
      )> }
    )>>>, groupMembers?: Maybe<Array<Maybe<(
      { __typename?: 'GroupUserType' }
      & Pick<GroupUserType, 'id'>
      & { user?: Maybe<(
        { __typename?: 'UserType' }
        & Pick<UserType, 'id' | 'email' | 'fullName'>
      )> }
    )>>>, groupUsers?: Maybe<Array<Maybe<(
      { __typename?: 'GroupUserType' }
      & Pick<GroupUserType, 'id' | 'role'>
      & { user?: Maybe<(
        { __typename?: 'UserType' }
        & Pick<UserType, 'id' | 'email' | 'fullName'>
      )> }
    )>>>, followers?: Maybe<Array<Maybe<(
      { __typename?: 'FollowType' }
      & Pick<FollowType, 'id' | 'userId' | 'groupId'>
      & { user?: Maybe<(
        { __typename?: 'UserType' }
        & Pick<UserType, 'id' | 'email' | 'fullName'>
      )> }
    )>>>, activities?: Maybe<Array<Maybe<(
      { __typename?: 'GroupActivityType' }
      & { comments?: Maybe<Array<Maybe<(
        { __typename?: 'GroupCommentType' }
        & { user?: Maybe<(
          { __typename?: 'UserType' }
          & Pick<UserType, 'id' | 'fullName' | 'avatar'>
        )> }
        & GroupCommentFragmentFragment
      )>>> }
      & GroupActivityFragmentFragment
    )>>> }
    & GroupFragmentFragment
  )> }
);

export type GroupFeatureEventsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GroupFeatureEventsQuery = (
  { __typename?: 'Query' }
  & { groupFeatureEvents: Array<Maybe<(
    { __typename?: 'EventType' }
    & Pick<EventType, 'id' | 'title' | 'mainImage' | 'mainImageUrl' | 'eventStatus' | 'eventStatusText' | 'eventDateText' | 'eventDateWday' | 'startTimeText' | 'location' | 'locationType' | 'locationTypeText' | 'organizer'>
  )>> }
);

export type GroupPastEventsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GroupPastEventsQuery = (
  { __typename?: 'Query' }
  & { groupPastEvents: Array<Maybe<(
    { __typename?: 'EventType' }
    & Pick<EventType, 'id' | 'title' | 'mainImage' | 'mainImageUrl' | 'eventStatus' | 'eventStatusText' | 'eventDateText' | 'eventDateWday' | 'startTimeText' | 'lastEventDateText' | 'lastEventDateWday' | 'lastStartTimeText' | 'location' | 'locationType' | 'locationTypeText' | 'organizer'>
  )>> }
);

export type GroupsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type GroupsQuery = (
  { __typename?: 'Query' }
  & { groups?: Maybe<(
    { __typename?: 'GroupsType' }
    & { groups?: Maybe<Array<Maybe<(
      { __typename?: 'GroupType' }
      & { groupAdmins?: Maybe<Array<Maybe<(
        { __typename?: 'GroupUserType' }
        & Pick<GroupUserType, 'id'>
        & { user?: Maybe<(
          { __typename?: 'UserType' }
          & Pick<UserType, 'id' | 'email' | 'fullName'>
        )> }
      )>>> }
      & GroupFragmentFragment
    )>>>, pagination?: Maybe<(
      { __typename?: 'Pagination' }
      & PaginationFragmentFragment
    )> }
  )> }
);

export type MyFollowsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyFollowsQuery = (
  { __typename?: 'Query' }
  & { myFollows: Array<Maybe<(
    { __typename?: 'GroupType' }
    & Pick<GroupType, 'id' | 'isAdmin' | 'name' | 'mainImage' | 'mainImageUrl'>
    & { users?: Maybe<Array<Maybe<(
      { __typename?: 'UserType' }
      & Pick<UserType, 'id' | 'email' | 'fullName'>
    )>>>, groupAdmins?: Maybe<Array<Maybe<(
      { __typename?: 'GroupUserType' }
      & Pick<GroupUserType, 'id'>
    )>>>, groupMembers?: Maybe<Array<Maybe<(
      { __typename?: 'GroupUserType' }
      & Pick<GroupUserType, 'id'>
    )>>>, followers?: Maybe<Array<Maybe<(
      { __typename?: 'FollowType' }
      & Pick<FollowType, 'id'>
    )>>> }
  )>> }
);

export type MyGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyGroupsQuery = (
  { __typename?: 'Query' }
  & { myGroups: Array<Maybe<(
    { __typename?: 'GroupType' }
    & { users?: Maybe<Array<Maybe<(
      { __typename?: 'UserType' }
      & Pick<UserType, 'id' | 'email' | 'fullName'>
    )>>>, groupAdmins?: Maybe<Array<Maybe<(
      { __typename?: 'GroupUserType' }
      & Pick<GroupUserType, 'id'>
    )>>>, groupMembers?: Maybe<Array<Maybe<(
      { __typename?: 'GroupUserType' }
      & Pick<GroupUserType, 'id'>
    )>>>, followers?: Maybe<Array<Maybe<(
      { __typename?: 'FollowType' }
      & Pick<FollowType, 'id'>
    )>>> }
    & GroupFragmentFragment
  )>> }
);

export type UnfollowMutationVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type UnfollowMutation = (
  { __typename?: 'Mutation' }
  & { unfollow?: Maybe<(
    { __typename?: 'UnFollowPayload' }
    & { group?: Maybe<(
      { __typename?: 'GroupType' }
      & Pick<GroupType, 'id'>
      & { followers?: Maybe<Array<Maybe<(
        { __typename?: 'FollowType' }
        & Pick<FollowType, 'id' | 'userId' | 'groupId'>
        & { user?: Maybe<(
          { __typename?: 'UserType' }
          & Pick<UserType, 'id' | 'fullName'>
        )> }
      )>>> }
    )> }
  )> }
);

export type IndustryTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type IndustryTypesQuery = (
  { __typename?: 'Query' }
  & { industryTypes?: Maybe<Array<Maybe<(
    { __typename?: 'IndustryTypeType' }
    & Pick<IndustryTypeType, 'id' | 'name'>
  )>>> }
);

export type NotificationsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type NotificationsQuery = (
  { __typename?: 'Query' }
  & { notifications?: Maybe<(
    { __typename?: 'Notifications' }
    & { notifications?: Maybe<Array<Maybe<(
      { __typename?: 'Notification' }
      & NotificationFragmentFragment
    )>>>, pagination?: Maybe<(
      { __typename?: 'Pagination' }
      & PaginationFragmentFragment
    )> }
  )> }
);

export type OptionsQueryVariables = Exact<{
  search?: Maybe<OptionSearch>;
}>;


export type OptionsQuery = (
  { __typename?: 'Query' }
  & { options?: Maybe<Array<(
    { __typename?: 'OptionType' }
    & OptionFragmentFragment
  )>> }
);

export type MyEntryOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyEntryOrdersQuery = (
  { __typename?: 'Query' }
  & { myEntryOrders: Array<Maybe<(
    { __typename?: 'OrderType' }
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & { eventSchedules?: Maybe<Array<Maybe<(
        { __typename?: 'EventScheduleType' }
        & EventScheduleFragmentFragment
      )>>> }
      & EventFragmentFragment
    )> }
    & OrderFragmentFragment
  )>> }
);

export type RoomCalendarsQueryVariables = Exact<{
  search: RoomCalendarSearch;
}>;


export type RoomCalendarsQuery = (
  { __typename?: 'Query' }
  & { roomCalendars: Array<Maybe<(
    { __typename?: 'RoomCalendarType' }
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & EventFragmentFragment
    )> }
    & RoomCalendarFragmentFragment
  )>> }
);

export type AllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUsersQuery = (
  { __typename?: 'Query' }
  & { allUsers?: Maybe<Array<(
    { __typename?: 'UserType' }
    & { address?: Maybe<(
      { __typename?: 'AddressType' }
      & { industryType?: Maybe<(
        { __typename?: 'IndustryTypeType' }
        & IndustryTypeFragmentFragment
      )> }
      & AddressFragmentFragment
    )> }
    & UserFragmentFragment
  )>> }
);

export const AddressFragmentFragmentDoc = gql`
    fragment addressFragment on AddressType {
  id
  orderId
  userId
  industryTypeId
  firstName
  lastName
  gender
  genderText
  birthdayYear
  birthdayMonth
  birthdayDay
  tel
  zipcode
  address1
  address2
  companyName
  companyNameKana
  companyBranchName
  companyPosition
  companyTel
  companyFax
}
    `;
export const BankFragmentFragmentDoc = gql`
    fragment bankFragment on BankType {
  id
  userId
  name
  branch
  accountType
  accountTypeText
  accountNumber
  accountName
}
    `;
export const ContactFragmentFragmentDoc = gql`
    fragment contactFragment on Contact {
  id
  firstName
  lastName
  email
  tel
  message
}
    `;
export const EventFragmentFragmentDoc = gql`
    fragment eventFragment on EventType {
  id
  groupId
  title
  description
  eventDate
  eventDatetimeText
  eventDateText
  eventDateWday
  startTimeText
  mainImage
  mainImageUrl
  eventStatus
  eventStatusText
  paymentStatus
  paymentStatusText
  akerunStatus
  akerunStatusText
  locationType
  locationTypeText
  location
  ticketQuantity
  ticketAmount
  isFree
  dueDate
  dueDateText
  dueTime
  dueTimeText
  address
  organizer
  informationEmail
  informationTel
  acmPrice
  taxAcmPrice
  guestCount
  cancelDate
  cancelDateText
  cancelTime
  cancelTimeText
  canCancel
  onShowpage
  isShowEventList
  eventType
  eventTypeText
  chargeId
  ticketPaymentMethod
  ticketPaymentMethodText
  ownerPaymentStatus
  ownerPaymentStatusText
  isReceipt
  receiptName
  ownerPaymentDate
  receiptStatus
  receiptStatusText
  orderCount
  totalSalesPrice
  totalFee
  totalPaymentPrice
}
    `;
export const EventOptionFragmentFragmentDoc = gql`
    fragment eventOptionFragment on EventOptionType {
  id
  eventId
  optionId
  isApply
}
    `;
export const EventScheduleFragmentFragmentDoc = gql`
    fragment eventScheduleFragment on EventScheduleType {
  id
  eventId
  eventDate
  eventDateText
  eventDateTextFull
  eventDateWday
  startTime
  startTimeText
  endTime
  endTimeText
}
    `;
export const GroupFragmentFragmentDoc = gql`
    fragment groupFragment on GroupType {
  id
  name
  mainImage
  mainImageUrl
  content
  location
  owner
  isAdmin
  groupAdminCount
  groupMemberCount
  groupFollowerCount
}
    `;
export const GroupActivityFragmentFragmentDoc = gql`
    fragment groupActivityFragment on GroupActivityType {
  id
  groupId
  userId
  title
}
    `;
export const GroupCommentFragmentFragmentDoc = gql`
    fragment groupCommentFragment on GroupCommentType {
  id
  groupActivityId
  userId
  message
  createdAtText
  isEdit
  isRemove
}
    `;
export const IndustryTypeFragmentFragmentDoc = gql`
    fragment industryTypeFragment on IndustryTypeType {
  id
  name
}
    `;
export const NotificationFragmentFragmentDoc = gql`
    fragment notificationFragment on Notification {
  id
  status
  statusText
  message
  startDate
  endDate
  startDateText
  endDateText
}
    `;
export const OptionFragmentFragmentDoc = gql`
    fragment optionFragment on OptionType {
  id
  optionType
  name
  description
}
    `;
export const OrderFragmentFragmentDoc = gql`
    fragment orderFragment on OrderType {
  id
  workflowState
  workflowStateText
  totalPrice
  completedAtText
  chargeId
  paymentState
  paymentStateText
}
    `;
export const PaginationFragmentFragmentDoc = gql`
    fragment paginationFragment on Pagination {
  resultsCount
  totalCount
  totalPages
  currentPage
  nextPage
  previousPage
  hasNextPage
  hasPreviousPage
}
    `;
export const PayjpCardFragmentFragmentDoc = gql`
    fragment payjpCardFragment on PayjpCardType {
  id
  cardId
  customerId
  created
  name
  last4
  expMonth
  expYear
}
    `;
export const PayjpCustomerFragmentFragmentDoc = gql`
    fragment payjpCustomerFragment on PayjpCustomerType {
  id
  userId
  customerId
}
    `;
export const PaymentFragmentFragmentDoc = gql`
    fragment paymentFragment on PaymentType {
  id
  eventId
  paymentMethod
}
    `;
export const RoomCalendarFragmentFragmentDoc = gql`
    fragment roomCalendarFragment on RoomCalendarType {
  id
  roomId
  eventId
  targetDate
  startTime
  startTimeText
  endTime
  endTimeText
  targetDateText
  calendarType
  memo
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment userFragment on UserType {
  id
  email
  avatar
  fullName
}
    `;
export const ChangePasswordDocument = gql`
    mutation changePassword($password: PasswordAttributes!) {
  changePassword(input: {password: $password}) {
    user {
      ...userFragment
    }
    error
  }
}
    ${UserFragmentFragmentDoc}`;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ConfirmDocument = gql`
    mutation confirm($token: String!) {
  confirm(input: {token: $token}) {
    user {
      ...userFragment
    }
    error
  }
}
    ${UserFragmentFragmentDoc}`;
export type ConfirmMutationFn = Apollo.MutationFunction<ConfirmMutation, ConfirmMutationVariables>;

/**
 * __useConfirmMutation__
 *
 * To run a mutation, you first call `useConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmMutation, { data, loading, error }] = useConfirmMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useConfirmMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmMutation, ConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmMutation, ConfirmMutationVariables>(ConfirmDocument, options);
      }
export type ConfirmMutationHookResult = ReturnType<typeof useConfirmMutation>;
export type ConfirmMutationResult = Apollo.MutationResult<ConfirmMutation>;
export type ConfirmMutationOptions = Apollo.BaseMutationOptions<ConfirmMutation, ConfirmMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation requestPasswordReset($email: String!) {
  requestPasswordReset(input: {email: $email}) {
    error
  }
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    error
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SigninDocument = gql`
    mutation signin($email: String!, $password: String!) {
  signin(input: {email: $email, password: $password}) {
    user {
      ...userFragment
    }
    error
  }
}
    ${UserFragmentFragmentDoc}`;
export type SigninMutationFn = Apollo.MutationFunction<SigninMutation, SigninMutationVariables>;

/**
 * __useSigninMutation__
 *
 * To run a mutation, you first call `useSigninMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinMutation, { data, loading, error }] = useSigninMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSigninMutation(baseOptions?: Apollo.MutationHookOptions<SigninMutation, SigninMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SigninMutation, SigninMutationVariables>(SigninDocument, options);
      }
export type SigninMutationHookResult = ReturnType<typeof useSigninMutation>;
export type SigninMutationResult = Apollo.MutationResult<SigninMutation>;
export type SigninMutationOptions = Apollo.BaseMutationOptions<SigninMutation, SigninMutationVariables>;
export const SignoutDocument = gql`
    mutation signout {
  signout(input: {}) {
    result
  }
}
    `;
export type SignoutMutationFn = Apollo.MutationFunction<SignoutMutation, SignoutMutationVariables>;

/**
 * __useSignoutMutation__
 *
 * To run a mutation, you first call `useSignoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signoutMutation, { data, loading, error }] = useSignoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignoutMutation(baseOptions?: Apollo.MutationHookOptions<SignoutMutation, SignoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignoutMutation, SignoutMutationVariables>(SignoutDocument, options);
      }
export type SignoutMutationHookResult = ReturnType<typeof useSignoutMutation>;
export type SignoutMutationResult = Apollo.MutationResult<SignoutMutation>;
export type SignoutMutationOptions = Apollo.BaseMutationOptions<SignoutMutation, SignoutMutationVariables>;
export const SignupDocument = gql`
    mutation signup($user: UserInputType!, $password: PasswordAttributes!) {
  signup(input: {userAttributes: $user, password: $password}) {
    user {
      id
    }
    error
  }
}
    `;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      user: // value for 'user'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const UpdateBankDocument = gql`
    mutation updateBank($bank: BankInputType!) {
  updateBank(input: {bank: $bank}) {
    bank {
      ...bankFragment
    }
  }
}
    ${BankFragmentFragmentDoc}`;
export type UpdateBankMutationFn = Apollo.MutationFunction<UpdateBankMutation, UpdateBankMutationVariables>;

/**
 * __useUpdateBankMutation__
 *
 * To run a mutation, you first call `useUpdateBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBankMutation, { data, loading, error }] = useUpdateBankMutation({
 *   variables: {
 *      bank: // value for 'bank'
 *   },
 * });
 */
export function useUpdateBankMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBankMutation, UpdateBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBankMutation, UpdateBankMutationVariables>(UpdateBankDocument, options);
      }
export type UpdateBankMutationHookResult = ReturnType<typeof useUpdateBankMutation>;
export type UpdateBankMutationResult = Apollo.MutationResult<UpdateBankMutation>;
export type UpdateBankMutationOptions = Apollo.BaseMutationOptions<UpdateBankMutation, UpdateBankMutationVariables>;
export const AddressDocument = gql`
    mutation address($id: ID!, $address: AddressInputType!) {
  address(input: {id: $id, address: $address}) {
    order {
      id
      user {
        ...userFragment
        address {
          ...addressFragment
          industryType {
            id
          }
        }
      }
    }
  }
}
    ${UserFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;
export type AddressMutationFn = Apollo.MutationFunction<AddressMutation, AddressMutationVariables>;

/**
 * __useAddressMutation__
 *
 * To run a mutation, you first call `useAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressMutation, { data, loading, error }] = useAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useAddressMutation(baseOptions?: Apollo.MutationHookOptions<AddressMutation, AddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddressMutation, AddressMutationVariables>(AddressDocument, options);
      }
export type AddressMutationHookResult = ReturnType<typeof useAddressMutation>;
export type AddressMutationResult = Apollo.MutationResult<AddressMutation>;
export type AddressMutationOptions = Apollo.BaseMutationOptions<AddressMutation, AddressMutationVariables>;
export const CreatePayjpCustomerDocument = gql`
    mutation createPayjpCustomer($attributes: PayjpCustomerAttributes!) {
  createPayjpCustomer(input: {attributes: $attributes}) {
    payjpCustomer {
      ...payjpCustomerFragment
      card {
        ...payjpCardFragment
      }
    }
  }
}
    ${PayjpCustomerFragmentFragmentDoc}
${PayjpCardFragmentFragmentDoc}`;
export type CreatePayjpCustomerMutationFn = Apollo.MutationFunction<CreatePayjpCustomerMutation, CreatePayjpCustomerMutationVariables>;

/**
 * __useCreatePayjpCustomerMutation__
 *
 * To run a mutation, you first call `useCreatePayjpCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayjpCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayjpCustomerMutation, { data, loading, error }] = useCreatePayjpCustomerMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreatePayjpCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayjpCustomerMutation, CreatePayjpCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayjpCustomerMutation, CreatePayjpCustomerMutationVariables>(CreatePayjpCustomerDocument, options);
      }
export type CreatePayjpCustomerMutationHookResult = ReturnType<typeof useCreatePayjpCustomerMutation>;
export type CreatePayjpCustomerMutationResult = Apollo.MutationResult<CreatePayjpCustomerMutation>;
export type CreatePayjpCustomerMutationOptions = Apollo.BaseMutationOptions<CreatePayjpCustomerMutation, CreatePayjpCustomerMutationVariables>;
export const OrderDocument = gql`
    mutation order($id: ID!) {
  order(input: {id: $id}) {
    order {
      ...orderFragment
    }
    error
  }
}
    ${OrderFragmentFragmentDoc}`;
export type OrderMutationFn = Apollo.MutationFunction<OrderMutation, OrderMutationVariables>;

/**
 * __useOrderMutation__
 *
 * To run a mutation, you first call `useOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderMutation, { data, loading, error }] = useOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderMutation(baseOptions?: Apollo.MutationHookOptions<OrderMutation, OrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderMutation, OrderMutationVariables>(OrderDocument, options);
      }
export type OrderMutationHookResult = ReturnType<typeof useOrderMutation>;
export type OrderMutationResult = Apollo.MutationResult<OrderMutation>;
export type OrderMutationOptions = Apollo.BaseMutationOptions<OrderMutation, OrderMutationVariables>;
export const PaymentDocument = gql`
    mutation payment($id: ID!) {
  payment(input: {id: $id}) {
    order {
      ...orderFragment
    }
  }
}
    ${OrderFragmentFragmentDoc}`;
export type PaymentMutationFn = Apollo.MutationFunction<PaymentMutation, PaymentMutationVariables>;

/**
 * __usePaymentMutation__
 *
 * To run a mutation, you first call `usePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMutation, { data, loading, error }] = usePaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentMutation(baseOptions?: Apollo.MutationHookOptions<PaymentMutation, PaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentMutation, PaymentMutationVariables>(PaymentDocument, options);
      }
export type PaymentMutationHookResult = ReturnType<typeof usePaymentMutation>;
export type PaymentMutationResult = Apollo.MutationResult<PaymentMutation>;
export type PaymentMutationOptions = Apollo.BaseMutationOptions<PaymentMutation, PaymentMutationVariables>;
export const UpdatePayjpCustomerDocument = gql`
    mutation updatePayjpCustomer($id: ID!, $attributes: PayjpCustomerAttributes!) {
  updatePayjpCustomer(input: {id: $id, attributes: $attributes}) {
    payjpCustomer {
      ...payjpCustomerFragment
      card {
        ...payjpCardFragment
      }
    }
  }
}
    ${PayjpCustomerFragmentFragmentDoc}
${PayjpCardFragmentFragmentDoc}`;
export type UpdatePayjpCustomerMutationFn = Apollo.MutationFunction<UpdatePayjpCustomerMutation, UpdatePayjpCustomerMutationVariables>;

/**
 * __useUpdatePayjpCustomerMutation__
 *
 * To run a mutation, you first call `useUpdatePayjpCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayjpCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayjpCustomerMutation, { data, loading, error }] = useUpdatePayjpCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdatePayjpCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePayjpCustomerMutation, UpdatePayjpCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePayjpCustomerMutation, UpdatePayjpCustomerMutationVariables>(UpdatePayjpCustomerDocument, options);
      }
export type UpdatePayjpCustomerMutationHookResult = ReturnType<typeof useUpdatePayjpCustomerMutation>;
export type UpdatePayjpCustomerMutationResult = Apollo.MutationResult<UpdatePayjpCustomerMutation>;
export type UpdatePayjpCustomerMutationOptions = Apollo.BaseMutationOptions<UpdatePayjpCustomerMutation, UpdatePayjpCustomerMutationVariables>;
export const CreateContactDocument = gql`
    mutation createContact($attributes: ContactAttributes!) {
  createContact(input: {attributes: $attributes}) {
    contact {
      ...contactFragment
    }
  }
}
    ${ContactFragmentFragmentDoc}`;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const AcceptEventDocument = gql`
    mutation acceptEvent($id: ID!, $event: EventInputType!) {
  acceptEvent(input: {id: $id, event: $event}) {
    event {
      ...eventFragment
    }
    error
  }
}
    ${EventFragmentFragmentDoc}`;
export type AcceptEventMutationFn = Apollo.MutationFunction<AcceptEventMutation, AcceptEventMutationVariables>;

/**
 * __useAcceptEventMutation__
 *
 * To run a mutation, you first call `useAcceptEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptEventMutation, { data, loading, error }] = useAcceptEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useAcceptEventMutation(baseOptions?: Apollo.MutationHookOptions<AcceptEventMutation, AcceptEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptEventMutation, AcceptEventMutationVariables>(AcceptEventDocument, options);
      }
export type AcceptEventMutationHookResult = ReturnType<typeof useAcceptEventMutation>;
export type AcceptEventMutationResult = Apollo.MutationResult<AcceptEventMutation>;
export type AcceptEventMutationOptions = Apollo.BaseMutationOptions<AcceptEventMutation, AcceptEventMutationVariables>;
export const ApplyCouponToEventDocument = gql`
    mutation applyCouponToEvent($id: ID!, $coupon: String!) {
  applyCouponToEvent(input: {id: $id, coupon: $coupon}) {
    event {
      ...eventFragment
    }
    error
  }
}
    ${EventFragmentFragmentDoc}`;
export type ApplyCouponToEventMutationFn = Apollo.MutationFunction<ApplyCouponToEventMutation, ApplyCouponToEventMutationVariables>;

/**
 * __useApplyCouponToEventMutation__
 *
 * To run a mutation, you first call `useApplyCouponToEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCouponToEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCouponToEventMutation, { data, loading, error }] = useApplyCouponToEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      coupon: // value for 'coupon'
 *   },
 * });
 */
export function useApplyCouponToEventMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCouponToEventMutation, ApplyCouponToEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyCouponToEventMutation, ApplyCouponToEventMutationVariables>(ApplyCouponToEventDocument, options);
      }
export type ApplyCouponToEventMutationHookResult = ReturnType<typeof useApplyCouponToEventMutation>;
export type ApplyCouponToEventMutationResult = Apollo.MutationResult<ApplyCouponToEventMutation>;
export type ApplyCouponToEventMutationOptions = Apollo.BaseMutationOptions<ApplyCouponToEventMutation, ApplyCouponToEventMutationVariables>;
export const ApplyEventDocument = gql`
    mutation applyEvent($id: ID!, $event: EventInputType!) {
  applyEvent(input: {id: $id, event: $event}) {
    event {
      ...eventFragment
    }
  }
}
    ${EventFragmentFragmentDoc}`;
export type ApplyEventMutationFn = Apollo.MutationFunction<ApplyEventMutation, ApplyEventMutationVariables>;

/**
 * __useApplyEventMutation__
 *
 * To run a mutation, you first call `useApplyEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyEventMutation, { data, loading, error }] = useApplyEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useApplyEventMutation(baseOptions?: Apollo.MutationHookOptions<ApplyEventMutation, ApplyEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyEventMutation, ApplyEventMutationVariables>(ApplyEventDocument, options);
      }
export type ApplyEventMutationHookResult = ReturnType<typeof useApplyEventMutation>;
export type ApplyEventMutationResult = Apollo.MutationResult<ApplyEventMutation>;
export type ApplyEventMutationOptions = Apollo.BaseMutationOptions<ApplyEventMutation, ApplyEventMutationVariables>;
export const CreateEventDocument = gql`
    mutation createEvent($event: EventInputType!) {
  createEvent(input: {event: $event}) {
    event {
      ...eventFragment
    }
  }
}
    ${EventFragmentFragmentDoc}`;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const RejectEventDocument = gql`
    mutation rejectEvent($id: ID!, $event: EventInputType!) {
  rejectEvent(input: {id: $id, event: $event}) {
    event {
      ...eventFragment
    }
  }
}
    ${EventFragmentFragmentDoc}`;
export type RejectEventMutationFn = Apollo.MutationFunction<RejectEventMutation, RejectEventMutationVariables>;

/**
 * __useRejectEventMutation__
 *
 * To run a mutation, you first call `useRejectEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectEventMutation, { data, loading, error }] = useRejectEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useRejectEventMutation(baseOptions?: Apollo.MutationHookOptions<RejectEventMutation, RejectEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectEventMutation, RejectEventMutationVariables>(RejectEventDocument, options);
      }
export type RejectEventMutationHookResult = ReturnType<typeof useRejectEventMutation>;
export type RejectEventMutationResult = Apollo.MutationResult<RejectEventMutation>;
export type RejectEventMutationOptions = Apollo.BaseMutationOptions<RejectEventMutation, RejectEventMutationVariables>;
export const RemoveEventDocument = gql`
    mutation removeEvent($id: ID!) {
  removeEvent(input: {id: $id}) {
    event {
      ...eventFragment
    }
  }
}
    ${EventFragmentFragmentDoc}`;
export type RemoveEventMutationFn = Apollo.MutationFunction<RemoveEventMutation, RemoveEventMutationVariables>;

/**
 * __useRemoveEventMutation__
 *
 * To run a mutation, you first call `useRemoveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventMutation, { data, loading, error }] = useRemoveEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEventMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventMutation, RemoveEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventMutation, RemoveEventMutationVariables>(RemoveEventDocument, options);
      }
export type RemoveEventMutationHookResult = ReturnType<typeof useRemoveEventMutation>;
export type RemoveEventMutationResult = Apollo.MutationResult<RemoveEventMutation>;
export type RemoveEventMutationOptions = Apollo.BaseMutationOptions<RemoveEventMutation, RemoveEventMutationVariables>;
export const RevertEventDocument = gql`
    mutation revertEvent($id: ID!) {
  revertEvent(input: {id: $id}) {
    event {
      ...eventFragment
    }
  }
}
    ${EventFragmentFragmentDoc}`;
export type RevertEventMutationFn = Apollo.MutationFunction<RevertEventMutation, RevertEventMutationVariables>;

/**
 * __useRevertEventMutation__
 *
 * To run a mutation, you first call `useRevertEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertEventMutation, { data, loading, error }] = useRevertEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevertEventMutation(baseOptions?: Apollo.MutationHookOptions<RevertEventMutation, RevertEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertEventMutation, RevertEventMutationVariables>(RevertEventDocument, options);
      }
export type RevertEventMutationHookResult = ReturnType<typeof useRevertEventMutation>;
export type RevertEventMutationResult = Apollo.MutationResult<RevertEventMutation>;
export type RevertEventMutationOptions = Apollo.BaseMutationOptions<RevertEventMutation, RevertEventMutationVariables>;
export const UpdateEventDocument = gql`
    mutation updateEvent($id: ID!, $event: EventInputType, $file: File) {
  updateEvent(input: {id: $id, event: $event, file: $file}) {
    event {
      ...eventFragment
    }
  }
}
    ${EventFragmentFragmentDoc}`;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      event: // value for 'event'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const UpdateEventOptionDocument = gql`
    mutation updateEventOption($id: ID!, $eventOption: EventOptionInputType!) {
  updateEventOption(input: {id: $id, eventOption: $eventOption}) {
    eventOption {
      ...eventOptionFragment
    }
  }
}
    ${EventOptionFragmentFragmentDoc}`;
export type UpdateEventOptionMutationFn = Apollo.MutationFunction<UpdateEventOptionMutation, UpdateEventOptionMutationVariables>;

/**
 * __useUpdateEventOptionMutation__
 *
 * To run a mutation, you first call `useUpdateEventOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventOptionMutation, { data, loading, error }] = useUpdateEventOptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      eventOption: // value for 'eventOption'
 *   },
 * });
 */
export function useUpdateEventOptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventOptionMutation, UpdateEventOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventOptionMutation, UpdateEventOptionMutationVariables>(UpdateEventOptionDocument, options);
      }
export type UpdateEventOptionMutationHookResult = ReturnType<typeof useUpdateEventOptionMutation>;
export type UpdateEventOptionMutationResult = Apollo.MutationResult<UpdateEventOptionMutation>;
export type UpdateEventOptionMutationOptions = Apollo.BaseMutationOptions<UpdateEventOptionMutation, UpdateEventOptionMutationVariables>;
export const CreateEventScheduleDocument = gql`
    mutation createEventSchedule($eventSchedule: EventScheduleInputType!) {
  createEventSchedule(input: {eventSchedule: $eventSchedule}) {
    event {
      ...eventFragment
      eventSchedules {
        ...eventScheduleFragment
      }
    }
  }
}
    ${EventFragmentFragmentDoc}
${EventScheduleFragmentFragmentDoc}`;
export type CreateEventScheduleMutationFn = Apollo.MutationFunction<CreateEventScheduleMutation, CreateEventScheduleMutationVariables>;

/**
 * __useCreateEventScheduleMutation__
 *
 * To run a mutation, you first call `useCreateEventScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventScheduleMutation, { data, loading, error }] = useCreateEventScheduleMutation({
 *   variables: {
 *      eventSchedule: // value for 'eventSchedule'
 *   },
 * });
 */
export function useCreateEventScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventScheduleMutation, CreateEventScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventScheduleMutation, CreateEventScheduleMutationVariables>(CreateEventScheduleDocument, options);
      }
export type CreateEventScheduleMutationHookResult = ReturnType<typeof useCreateEventScheduleMutation>;
export type CreateEventScheduleMutationResult = Apollo.MutationResult<CreateEventScheduleMutation>;
export type CreateEventScheduleMutationOptions = Apollo.BaseMutationOptions<CreateEventScheduleMutation, CreateEventScheduleMutationVariables>;
export const RemoveEventScheduleDocument = gql`
    mutation removeEventSchedule($id: ID!) {
  removeEventSchedule(input: {id: $id}) {
    event {
      ...eventFragment
      eventSchedules {
        ...eventScheduleFragment
      }
    }
  }
}
    ${EventFragmentFragmentDoc}
${EventScheduleFragmentFragmentDoc}`;
export type RemoveEventScheduleMutationFn = Apollo.MutationFunction<RemoveEventScheduleMutation, RemoveEventScheduleMutationVariables>;

/**
 * __useRemoveEventScheduleMutation__
 *
 * To run a mutation, you first call `useRemoveEventScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventScheduleMutation, { data, loading, error }] = useRemoveEventScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEventScheduleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventScheduleMutation, RemoveEventScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventScheduleMutation, RemoveEventScheduleMutationVariables>(RemoveEventScheduleDocument, options);
      }
export type RemoveEventScheduleMutationHookResult = ReturnType<typeof useRemoveEventScheduleMutation>;
export type RemoveEventScheduleMutationResult = Apollo.MutationResult<RemoveEventScheduleMutation>;
export type RemoveEventScheduleMutationOptions = Apollo.BaseMutationOptions<RemoveEventScheduleMutation, RemoveEventScheduleMutationVariables>;
export const UpdateEventScheduleDocument = gql`
    mutation updateEventSchedule($id: ID!, $eventSchedule: EventScheduleInputType!) {
  updateEventSchedule(input: {id: $id, eventSchedule: $eventSchedule}) {
    event {
      ...eventFragment
      eventSchedules {
        ...eventScheduleFragment
      }
    }
  }
}
    ${EventFragmentFragmentDoc}
${EventScheduleFragmentFragmentDoc}`;
export type UpdateEventScheduleMutationFn = Apollo.MutationFunction<UpdateEventScheduleMutation, UpdateEventScheduleMutationVariables>;

/**
 * __useUpdateEventScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateEventScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventScheduleMutation, { data, loading, error }] = useUpdateEventScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      eventSchedule: // value for 'eventSchedule'
 *   },
 * });
 */
export function useUpdateEventScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventScheduleMutation, UpdateEventScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventScheduleMutation, UpdateEventScheduleMutationVariables>(UpdateEventScheduleDocument, options);
      }
export type UpdateEventScheduleMutationHookResult = ReturnType<typeof useUpdateEventScheduleMutation>;
export type UpdateEventScheduleMutationResult = Apollo.MutationResult<UpdateEventScheduleMutation>;
export type UpdateEventScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateEventScheduleMutation, UpdateEventScheduleMutationVariables>;
export const AcceptRequestDocument = gql`
    mutation acceptRequest($id: ID!) {
  acceptRequest(input: {id: $id}) {
    request {
      id
      groupId
      userId
      status
    }
  }
}
    `;
export type AcceptRequestMutationFn = Apollo.MutationFunction<AcceptRequestMutation, AcceptRequestMutationVariables>;

/**
 * __useAcceptRequestMutation__
 *
 * To run a mutation, you first call `useAcceptRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptRequestMutation, { data, loading, error }] = useAcceptRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptRequestMutation, AcceptRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptRequestMutation, AcceptRequestMutationVariables>(AcceptRequestDocument, options);
      }
export type AcceptRequestMutationHookResult = ReturnType<typeof useAcceptRequestMutation>;
export type AcceptRequestMutationResult = Apollo.MutationResult<AcceptRequestMutation>;
export type AcceptRequestMutationOptions = Apollo.BaseMutationOptions<AcceptRequestMutation, AcceptRequestMutationVariables>;
export const AddGroupActivityDocument = gql`
    mutation addGroupActivity($attributes: GroupActivityAttributes!) {
  addGroupActivity(input: {attributes: $attributes}) {
    group {
      id
      isAdmin
      name
      activities {
        id
        groupId
        userId
        title
        comments {
          id
          groupActivityId
          userId
          message
          createdAtText
          isEdit
          isRemove
          user {
            id
            fullName
          }
        }
      }
    }
  }
}
    `;
export type AddGroupActivityMutationFn = Apollo.MutationFunction<AddGroupActivityMutation, AddGroupActivityMutationVariables>;

/**
 * __useAddGroupActivityMutation__
 *
 * To run a mutation, you first call `useAddGroupActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGroupActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGroupActivityMutation, { data, loading, error }] = useAddGroupActivityMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAddGroupActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddGroupActivityMutation, AddGroupActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGroupActivityMutation, AddGroupActivityMutationVariables>(AddGroupActivityDocument, options);
      }
export type AddGroupActivityMutationHookResult = ReturnType<typeof useAddGroupActivityMutation>;
export type AddGroupActivityMutationResult = Apollo.MutationResult<AddGroupActivityMutation>;
export type AddGroupActivityMutationOptions = Apollo.BaseMutationOptions<AddGroupActivityMutation, AddGroupActivityMutationVariables>;
export const AddGroupCommentDocument = gql`
    mutation addGroupComment($id: ID!, $attributes: CommentInputType!) {
  addGroupComment(input: {id: $id, attributes: $attributes}) {
    comment {
      id
      groupActivityId
      userId
      message
      createdAtText
      isEdit
      isRemove
      user {
        id
        fullName
      }
    }
  }
}
    `;
export type AddGroupCommentMutationFn = Apollo.MutationFunction<AddGroupCommentMutation, AddGroupCommentMutationVariables>;

/**
 * __useAddGroupCommentMutation__
 *
 * To run a mutation, you first call `useAddGroupCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGroupCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGroupCommentMutation, { data, loading, error }] = useAddGroupCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAddGroupCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddGroupCommentMutation, AddGroupCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGroupCommentMutation, AddGroupCommentMutationVariables>(AddGroupCommentDocument, options);
      }
export type AddGroupCommentMutationHookResult = ReturnType<typeof useAddGroupCommentMutation>;
export type AddGroupCommentMutationResult = Apollo.MutationResult<AddGroupCommentMutation>;
export type AddGroupCommentMutationOptions = Apollo.BaseMutationOptions<AddGroupCommentMutation, AddGroupCommentMutationVariables>;
export const CreateGroupDocument = gql`
    mutation createGroup($group: GroupInputType!) {
  createGroup(input: {group: $group}) {
    group {
      ...groupFragment
    }
  }
}
    ${GroupFragmentFragmentDoc}`;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      group: // value for 'group'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const CreateRequestDocument = gql`
    mutation createRequest($request: RequestInputType!) {
  createRequest(input: {request: $request}) {
    group {
      ...groupFragment
    }
  }
}
    ${GroupFragmentFragmentDoc}`;
export type CreateRequestMutationFn = Apollo.MutationFunction<CreateRequestMutation, CreateRequestMutationVariables>;

/**
 * __useCreateRequestMutation__
 *
 * To run a mutation, you first call `useCreateRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRequestMutation, { data, loading, error }] = useCreateRequestMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCreateRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateRequestMutation, CreateRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRequestMutation, CreateRequestMutationVariables>(CreateRequestDocument, options);
      }
export type CreateRequestMutationHookResult = ReturnType<typeof useCreateRequestMutation>;
export type CreateRequestMutationResult = Apollo.MutationResult<CreateRequestMutation>;
export type CreateRequestMutationOptions = Apollo.BaseMutationOptions<CreateRequestMutation, CreateRequestMutationVariables>;
export const DestroyGroupUserDocument = gql`
    mutation destroyGroupUser($id: ID!) {
  destroyGroupUser(input: {id: $id}) {
    group {
      id
      groupAdmins {
        id
        user {
          id
          email
          fullName
        }
      }
      groupMembers {
        id
        user {
          id
          email
          fullName
        }
      }
    }
  }
}
    `;
export type DestroyGroupUserMutationFn = Apollo.MutationFunction<DestroyGroupUserMutation, DestroyGroupUserMutationVariables>;

/**
 * __useDestroyGroupUserMutation__
 *
 * To run a mutation, you first call `useDestroyGroupUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyGroupUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyGroupUserMutation, { data, loading, error }] = useDestroyGroupUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyGroupUserMutation(baseOptions?: Apollo.MutationHookOptions<DestroyGroupUserMutation, DestroyGroupUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyGroupUserMutation, DestroyGroupUserMutationVariables>(DestroyGroupUserDocument, options);
      }
export type DestroyGroupUserMutationHookResult = ReturnType<typeof useDestroyGroupUserMutation>;
export type DestroyGroupUserMutationResult = Apollo.MutationResult<DestroyGroupUserMutation>;
export type DestroyGroupUserMutationOptions = Apollo.BaseMutationOptions<DestroyGroupUserMutation, DestroyGroupUserMutationVariables>;
export const RejectRequestDocument = gql`
    mutation rejectRequest($id: ID!) {
  rejectRequest(input: {id: $id}) {
    request {
      id
      groupId
      userId
      status
    }
  }
}
    `;
export type RejectRequestMutationFn = Apollo.MutationFunction<RejectRequestMutation, RejectRequestMutationVariables>;

/**
 * __useRejectRequestMutation__
 *
 * To run a mutation, you first call `useRejectRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectRequestMutation, { data, loading, error }] = useRejectRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRejectRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectRequestMutation, RejectRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectRequestMutation, RejectRequestMutationVariables>(RejectRequestDocument, options);
      }
export type RejectRequestMutationHookResult = ReturnType<typeof useRejectRequestMutation>;
export type RejectRequestMutationResult = Apollo.MutationResult<RejectRequestMutation>;
export type RejectRequestMutationOptions = Apollo.BaseMutationOptions<RejectRequestMutation, RejectRequestMutationVariables>;
export const RemoveGroupActivityDocument = gql`
    mutation removeGroupActivity($id: ID!) {
  removeGroupActivity(input: {id: $id}) {
    group {
      id
      isAdmin
      name
      activities {
        id
        groupId
        userId
        title
        comments {
          id
          groupActivityId
          userId
          message
          createdAtText
          isEdit
          isRemove
          user {
            id
            fullName
          }
        }
      }
    }
  }
}
    `;
export type RemoveGroupActivityMutationFn = Apollo.MutationFunction<RemoveGroupActivityMutation, RemoveGroupActivityMutationVariables>;

/**
 * __useRemoveGroupActivityMutation__
 *
 * To run a mutation, you first call `useRemoveGroupActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupActivityMutation, { data, loading, error }] = useRemoveGroupActivityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGroupActivityMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGroupActivityMutation, RemoveGroupActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGroupActivityMutation, RemoveGroupActivityMutationVariables>(RemoveGroupActivityDocument, options);
      }
export type RemoveGroupActivityMutationHookResult = ReturnType<typeof useRemoveGroupActivityMutation>;
export type RemoveGroupActivityMutationResult = Apollo.MutationResult<RemoveGroupActivityMutation>;
export type RemoveGroupActivityMutationOptions = Apollo.BaseMutationOptions<RemoveGroupActivityMutation, RemoveGroupActivityMutationVariables>;
export const RemoveGroupCommentDocument = gql`
    mutation removeGroupComment($id: ID!) {
  removeGroupComment(input: {id: $id}) {
    comment {
      id
      groupActivityId
      userId
      message
      createdAtText
      isEdit
      isRemove
      user {
        id
        fullName
      }
    }
  }
}
    `;
export type RemoveGroupCommentMutationFn = Apollo.MutationFunction<RemoveGroupCommentMutation, RemoveGroupCommentMutationVariables>;

/**
 * __useRemoveGroupCommentMutation__
 *
 * To run a mutation, you first call `useRemoveGroupCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupCommentMutation, { data, loading, error }] = useRemoveGroupCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGroupCommentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGroupCommentMutation, RemoveGroupCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGroupCommentMutation, RemoveGroupCommentMutationVariables>(RemoveGroupCommentDocument, options);
      }
export type RemoveGroupCommentMutationHookResult = ReturnType<typeof useRemoveGroupCommentMutation>;
export type RemoveGroupCommentMutationResult = Apollo.MutationResult<RemoveGroupCommentMutation>;
export type RemoveGroupCommentMutationOptions = Apollo.BaseMutationOptions<RemoveGroupCommentMutation, RemoveGroupCommentMutationVariables>;
export const SendGroupMailDocument = gql`
    mutation sendGroupMail($groupMail: GroupMailInputType!) {
  sendGroupMail(input: {groupMail: $groupMail}) {
    groupMail {
      id
    }
  }
}
    `;
export type SendGroupMailMutationFn = Apollo.MutationFunction<SendGroupMailMutation, SendGroupMailMutationVariables>;

/**
 * __useSendGroupMailMutation__
 *
 * To run a mutation, you first call `useSendGroupMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGroupMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGroupMailMutation, { data, loading, error }] = useSendGroupMailMutation({
 *   variables: {
 *      groupMail: // value for 'groupMail'
 *   },
 * });
 */
export function useSendGroupMailMutation(baseOptions?: Apollo.MutationHookOptions<SendGroupMailMutation, SendGroupMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendGroupMailMutation, SendGroupMailMutationVariables>(SendGroupMailDocument, options);
      }
export type SendGroupMailMutationHookResult = ReturnType<typeof useSendGroupMailMutation>;
export type SendGroupMailMutationResult = Apollo.MutationResult<SendGroupMailMutation>;
export type SendGroupMailMutationOptions = Apollo.BaseMutationOptions<SendGroupMailMutation, SendGroupMailMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation updateGroup($id: ID!, $group: GroupInputType!, $file: File) {
  updateGroup(input: {id: $id, group: $group, file: $file}) {
    group {
      ...groupFragment
    }
  }
}
    ${GroupFragmentFragmentDoc}`;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      group: // value for 'group'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const UpdateGroupActivityDocument = gql`
    mutation updateGroupActivity($id: ID!, $attributes: GroupActivityAttributes!) {
  updateGroupActivity(input: {id: $id, attributes: $attributes}) {
    groupActivity {
      id
      title
    }
  }
}
    `;
export type UpdateGroupActivityMutationFn = Apollo.MutationFunction<UpdateGroupActivityMutation, UpdateGroupActivityMutationVariables>;

/**
 * __useUpdateGroupActivityMutation__
 *
 * To run a mutation, you first call `useUpdateGroupActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupActivityMutation, { data, loading, error }] = useUpdateGroupActivityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateGroupActivityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupActivityMutation, UpdateGroupActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupActivityMutation, UpdateGroupActivityMutationVariables>(UpdateGroupActivityDocument, options);
      }
export type UpdateGroupActivityMutationHookResult = ReturnType<typeof useUpdateGroupActivityMutation>;
export type UpdateGroupActivityMutationResult = Apollo.MutationResult<UpdateGroupActivityMutation>;
export type UpdateGroupActivityMutationOptions = Apollo.BaseMutationOptions<UpdateGroupActivityMutation, UpdateGroupActivityMutationVariables>;
export const UpdateGroupCommentDocument = gql`
    mutation updateGroupComment($id: ID!, $attributes: CommentInputType!) {
  updateGroupComment(input: {id: $id, attributes: $attributes}) {
    comment {
      id
      message
      isEdit
      isRemove
    }
  }
}
    `;
export type UpdateGroupCommentMutationFn = Apollo.MutationFunction<UpdateGroupCommentMutation, UpdateGroupCommentMutationVariables>;

/**
 * __useUpdateGroupCommentMutation__
 *
 * To run a mutation, you first call `useUpdateGroupCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupCommentMutation, { data, loading, error }] = useUpdateGroupCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateGroupCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupCommentMutation, UpdateGroupCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupCommentMutation, UpdateGroupCommentMutationVariables>(UpdateGroupCommentDocument, options);
      }
export type UpdateGroupCommentMutationHookResult = ReturnType<typeof useUpdateGroupCommentMutation>;
export type UpdateGroupCommentMutationResult = Apollo.MutationResult<UpdateGroupCommentMutation>;
export type UpdateGroupCommentMutationOptions = Apollo.BaseMutationOptions<UpdateGroupCommentMutation, UpdateGroupCommentMutationVariables>;
export const UpdateGroupUserDocument = gql`
    mutation updateGroupUser($id: ID!, $groupUser: GroupUserInputType!) {
  updateGroupUser(input: {id: $id, groupUser: $groupUser}) {
    group {
      id
      groupAdmins {
        id
        user {
          id
          email
          fullName
        }
      }
      groupMembers {
        id
        user {
          id
          email
          fullName
        }
      }
    }
  }
}
    `;
export type UpdateGroupUserMutationFn = Apollo.MutationFunction<UpdateGroupUserMutation, UpdateGroupUserMutationVariables>;

/**
 * __useUpdateGroupUserMutation__
 *
 * To run a mutation, you first call `useUpdateGroupUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupUserMutation, { data, loading, error }] = useUpdateGroupUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      groupUser: // value for 'groupUser'
 *   },
 * });
 */
export function useUpdateGroupUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupUserMutation, UpdateGroupUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupUserMutation, UpdateGroupUserMutationVariables>(UpdateGroupUserDocument, options);
      }
export type UpdateGroupUserMutationHookResult = ReturnType<typeof useUpdateGroupUserMutation>;
export type UpdateGroupUserMutationResult = Apollo.MutationResult<UpdateGroupUserMutation>;
export type UpdateGroupUserMutationOptions = Apollo.BaseMutationOptions<UpdateGroupUserMutation, UpdateGroupUserMutationVariables>;
export const CreateNotificationDocument = gql`
    mutation createNotification($attributes: NotificationAttributes!) {
  createNotification(input: {attributes: $attributes}) {
    notification {
      ...notificationFragment
    }
  }
}
    ${NotificationFragmentFragmentDoc}`;
export type CreateNotificationMutationFn = Apollo.MutationFunction<CreateNotificationMutation, CreateNotificationMutationVariables>;

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationMutation, CreateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationMutation, CreateNotificationMutationVariables>(CreateNotificationDocument, options);
      }
export type CreateNotificationMutationHookResult = ReturnType<typeof useCreateNotificationMutation>;
export type CreateNotificationMutationResult = Apollo.MutationResult<CreateNotificationMutation>;
export type CreateNotificationMutationOptions = Apollo.BaseMutationOptions<CreateNotificationMutation, CreateNotificationMutationVariables>;
export const UpdateNotificationDocument = gql`
    mutation updateNotification($id: ID!, $attributes: NotificationAttributes!) {
  updateNotification(input: {id: $id, attributes: $attributes}) {
    notification {
      ...notificationFragment
    }
  }
}
    ${NotificationFragmentFragmentDoc}`;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<UpdateNotificationMutation, UpdateNotificationMutationVariables>;

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationMutation, UpdateNotificationMutationVariables>(UpdateNotificationDocument, options);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = Apollo.MutationResult<UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const CancelOrderDocument = gql`
    mutation cancelOrder($id: ID!) {
  cancelOrder(input: {id: $id}) {
    order {
      ...orderFragment
    }
    error
  }
}
    ${OrderFragmentFragmentDoc}`;
export type CancelOrderMutationFn = Apollo.MutationFunction<CancelOrderMutation, CancelOrderMutationVariables>;

/**
 * __useCancelOrderMutation__
 *
 * To run a mutation, you first call `useCancelOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrderMutation, { data, loading, error }] = useCancelOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelOrderMutation, CancelOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOrderMutation, CancelOrderMutationVariables>(CancelOrderDocument, options);
      }
export type CancelOrderMutationHookResult = ReturnType<typeof useCancelOrderMutation>;
export type CancelOrderMutationResult = Apollo.MutationResult<CancelOrderMutation>;
export type CancelOrderMutationOptions = Apollo.BaseMutationOptions<CancelOrderMutation, CancelOrderMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation updateOrder($id: ID!, $order: OrderInputType!) {
  updateOrder(input: {id: $id, order: $order}) {
    order {
      ...orderFragment
    }
  }
}
    ${OrderFragmentFragmentDoc}`;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const CreatePaymentDocument = gql`
    mutation createPayment($attributes: PaymentInputType!) {
  createPayment(input: {attributes: $attributes}) {
    payment {
      ...paymentFragment
    }
  }
}
    ${PaymentFragmentFragmentDoc}`;
export type CreatePaymentMutationFn = Apollo.MutationFunction<CreatePaymentMutation, CreatePaymentMutationVariables>;

/**
 * __useCreatePaymentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMutation, { data, loading, error }] = useCreatePaymentMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentMutation, CreatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument, options);
      }
export type CreatePaymentMutationHookResult = ReturnType<typeof useCreatePaymentMutation>;
export type CreatePaymentMutationResult = Apollo.MutationResult<CreatePaymentMutation>;
export type CreatePaymentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMutation, CreatePaymentMutationVariables>;
export const UpdatePaymentDocument = gql`
    mutation updatePayment($id: ID!, $attributes: PaymentInputType!) {
  updatePayment(input: {id: $id, attributes: $attributes}) {
    payment {
      ...paymentFragment
    }
  }
}
    ${PaymentFragmentFragmentDoc}`;
export type UpdatePaymentMutationFn = Apollo.MutationFunction<UpdatePaymentMutation, UpdatePaymentMutationVariables>;

/**
 * __useUpdatePaymentMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMutation, { data, loading, error }] = useUpdatePaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMutation, UpdatePaymentMutationVariables>(UpdatePaymentDocument, options);
      }
export type UpdatePaymentMutationHookResult = ReturnType<typeof useUpdatePaymentMutation>;
export type UpdatePaymentMutationResult = Apollo.MutationResult<UpdatePaymentMutation>;
export type UpdatePaymentMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>;
export const CreateRoomCalendarDocument = gql`
    mutation createRoomCalendar($roomCalendar: RoomCalendarInputType!) {
  createRoomCalendar(input: {roomCalendar: $roomCalendar}) {
    roomCalendar {
      ...roomCalendarFragment
      event {
        ...eventFragment
      }
    }
    error
  }
}
    ${RoomCalendarFragmentFragmentDoc}
${EventFragmentFragmentDoc}`;
export type CreateRoomCalendarMutationFn = Apollo.MutationFunction<CreateRoomCalendarMutation, CreateRoomCalendarMutationVariables>;

/**
 * __useCreateRoomCalendarMutation__
 *
 * To run a mutation, you first call `useCreateRoomCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomCalendarMutation, { data, loading, error }] = useCreateRoomCalendarMutation({
 *   variables: {
 *      roomCalendar: // value for 'roomCalendar'
 *   },
 * });
 */
export function useCreateRoomCalendarMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoomCalendarMutation, CreateRoomCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoomCalendarMutation, CreateRoomCalendarMutationVariables>(CreateRoomCalendarDocument, options);
      }
export type CreateRoomCalendarMutationHookResult = ReturnType<typeof useCreateRoomCalendarMutation>;
export type CreateRoomCalendarMutationResult = Apollo.MutationResult<CreateRoomCalendarMutation>;
export type CreateRoomCalendarMutationOptions = Apollo.BaseMutationOptions<CreateRoomCalendarMutation, CreateRoomCalendarMutationVariables>;
export const RemoveRoomCalendarDocument = gql`
    mutation removeRoomCalendar($id: ID!) {
  removeRoomCalendar(input: {id: $id}) {
    id
    error
  }
}
    `;
export type RemoveRoomCalendarMutationFn = Apollo.MutationFunction<RemoveRoomCalendarMutation, RemoveRoomCalendarMutationVariables>;

/**
 * __useRemoveRoomCalendarMutation__
 *
 * To run a mutation, you first call `useRemoveRoomCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoomCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoomCalendarMutation, { data, loading, error }] = useRemoveRoomCalendarMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveRoomCalendarMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRoomCalendarMutation, RemoveRoomCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRoomCalendarMutation, RemoveRoomCalendarMutationVariables>(RemoveRoomCalendarDocument, options);
      }
export type RemoveRoomCalendarMutationHookResult = ReturnType<typeof useRemoveRoomCalendarMutation>;
export type RemoveRoomCalendarMutationResult = Apollo.MutationResult<RemoveRoomCalendarMutation>;
export type RemoveRoomCalendarMutationOptions = Apollo.BaseMutationOptions<RemoveRoomCalendarMutation, RemoveRoomCalendarMutationVariables>;
export const UpdateRoomCalendarDocument = gql`
    mutation updateRoomCalendar($id: ID!, $attributes: RoomCalendarInputType!) {
  updateRoomCalendar(input: {id: $id, attributes: $attributes}) {
    roomCalendar {
      ...roomCalendarFragment
    }
  }
}
    ${RoomCalendarFragmentFragmentDoc}`;
export type UpdateRoomCalendarMutationFn = Apollo.MutationFunction<UpdateRoomCalendarMutation, UpdateRoomCalendarMutationVariables>;

/**
 * __useUpdateRoomCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateRoomCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomCalendarMutation, { data, loading, error }] = useUpdateRoomCalendarMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateRoomCalendarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomCalendarMutation, UpdateRoomCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomCalendarMutation, UpdateRoomCalendarMutationVariables>(UpdateRoomCalendarDocument, options);
      }
export type UpdateRoomCalendarMutationHookResult = ReturnType<typeof useUpdateRoomCalendarMutation>;
export type UpdateRoomCalendarMutationResult = Apollo.MutationResult<UpdateRoomCalendarMutation>;
export type UpdateRoomCalendarMutationOptions = Apollo.BaseMutationOptions<UpdateRoomCalendarMutation, UpdateRoomCalendarMutationVariables>;
export const UpdateAddressDocument = gql`
    mutation updateAddress($id: ID!, $attributes: AddressInputType) {
  updateAddress(input: {id: $id, attributes: $attributes}) {
    address {
      ...addressFragment
    }
  }
}
    ${AddressFragmentFragmentDoc}`;
export type UpdateAddressMutationFn = Apollo.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($id: ID!, $attributes: UserInputType) {
  updatePassword(input: {id: $id, attributes: $attributes}) {
    user {
      ...userFragment
    }
    error
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: ID!, $file: File, $user: UserInputType) {
  updateUser(input: {id: $id, file: $file, user: $user}) {
    user {
      ...userFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      file: // value for 'file'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const BankDocument = gql`
    query bank {
  bank {
    ...bankFragment
  }
}
    ${BankFragmentFragmentDoc}`;

/**
 * __useBankQuery__
 *
 * To run a query within a React component, call `useBankQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankQuery(baseOptions?: Apollo.QueryHookOptions<BankQuery, BankQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankQuery, BankQueryVariables>(BankDocument, options);
      }
export function useBankLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankQuery, BankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankQuery, BankQueryVariables>(BankDocument, options);
        }
export type BankQueryHookResult = ReturnType<typeof useBankQuery>;
export type BankLazyQueryHookResult = ReturnType<typeof useBankLazyQuery>;
export type BankQueryResult = Apollo.QueryResult<BankQuery, BankQueryVariables>;
export const CurrentOrderDocument = gql`
    query currentOrder {
  currentOrder {
    ...orderFragment
    event {
      ...eventFragment
      eventSchedules {
        ...eventScheduleFragment
      }
    }
  }
}
    ${OrderFragmentFragmentDoc}
${EventFragmentFragmentDoc}
${EventScheduleFragmentFragmentDoc}`;

/**
 * __useCurrentOrderQuery__
 *
 * To run a query within a React component, call `useCurrentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentOrderQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentOrderQuery(baseOptions?: Apollo.QueryHookOptions<CurrentOrderQuery, CurrentOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentOrderQuery, CurrentOrderQueryVariables>(CurrentOrderDocument, options);
      }
export function useCurrentOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentOrderQuery, CurrentOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentOrderQuery, CurrentOrderQueryVariables>(CurrentOrderDocument, options);
        }
export type CurrentOrderQueryHookResult = ReturnType<typeof useCurrentOrderQuery>;
export type CurrentOrderLazyQueryHookResult = ReturnType<typeof useCurrentOrderLazyQuery>;
export type CurrentOrderQueryResult = Apollo.QueryResult<CurrentOrderQuery, CurrentOrderQueryVariables>;
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    ...userFragment
    payjpCustomer {
      id
      card {
        id
        cardId
        customerId
        created
        name
        last4
        expMonth
        expYear
      }
    }
    address {
      ...addressFragment
      industryType {
        id
      }
    }
  }
}
    ${UserFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const EventDocument = gql`
    query event($id: ID!) {
  myEvents {
    ...eventFragment
  }
  event(id: $id) {
    ...eventFragment
    overFirstEventDate
    eventSchedules {
      ...eventScheduleFragment
    }
    acceptedOrders {
      ...orderFragment
      user {
        ...userFragment
        payjpCustomer {
          id
          userId
          customerId
        }
        address {
          id
          userId
          tel
        }
      }
    }
    user {
      ...userFragment
      payjpCustomer {
        id
        userId
        customerId
      }
      address {
        ...addressFragment
        industryType {
          id
          name
        }
      }
      bank {
        ...bankFragment
      }
      id
    }
    roomCalendars {
      ...roomCalendarFragment
      room {
        id
        name
      }
    }
    eventOptions {
      ...eventOptionFragment
      option {
        id
        name
        optionType
        description
      }
    }
    payment {
      ...paymentFragment
      payjpCard {
        id
        cardId
        last4
        expMonth
        expYear
      }
    }
    groupId
    group {
      id
      name
      mainImageUrl
      followers {
        id
        groupId
        userId
      }
    }
    user {
      id
    }
  }
  options {
    id
    name
    optionType
    description
  }
  rooms {
    id
    name
  }
}
    ${EventFragmentFragmentDoc}
${EventScheduleFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${BankFragmentFragmentDoc}
${RoomCalendarFragmentFragmentDoc}
${EventOptionFragmentFragmentDoc}
${PaymentFragmentFragmentDoc}`;

/**
 * __useEventQuery__
 *
 * To run a query within a React component, call `useEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventQuery(baseOptions: Apollo.QueryHookOptions<EventQuery, EventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventQuery, EventQueryVariables>(EventDocument, options);
      }
export function useEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventQuery, EventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventQuery, EventQueryVariables>(EventDocument, options);
        }
export type EventQueryHookResult = ReturnType<typeof useEventQuery>;
export type EventLazyQueryHookResult = ReturnType<typeof useEventLazyQuery>;
export type EventQueryResult = Apollo.QueryResult<EventQuery, EventQueryVariables>;
export const EventsDocument = gql`
    query events($page: Int!, $search: EventSearch) {
  events(page: $page, search: $search) {
    events {
      ...eventFragment
      eventSchedules {
        ...eventScheduleFragment
      }
      user {
        ...userFragment
      }
      payment {
        ...paymentFragment
      }
    }
    pagination {
      ...paginationFragment
    }
  }
}
    ${EventFragmentFragmentDoc}
${EventScheduleFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${PaymentFragmentFragmentDoc}
${PaginationFragmentFragmentDoc}`;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useEventsQuery(baseOptions: Apollo.QueryHookOptions<EventsQuery, EventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
      }
export function useEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
        }
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsQueryResult = Apollo.QueryResult<EventsQuery, EventsQueryVariables>;
export const MyEventsDocument = gql`
    query myEvents {
  myEvents {
    ...eventFragment
    eventSchedules {
      ...eventScheduleFragment
    }
    group {
      id
      name
    }
  }
}
    ${EventFragmentFragmentDoc}
${EventScheduleFragmentFragmentDoc}`;

/**
 * __useMyEventsQuery__
 *
 * To run a query within a React component, call `useMyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEventsQuery(baseOptions?: Apollo.QueryHookOptions<MyEventsQuery, MyEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEventsQuery, MyEventsQueryVariables>(MyEventsDocument, options);
      }
export function useMyEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEventsQuery, MyEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEventsQuery, MyEventsQueryVariables>(MyEventsDocument, options);
        }
export type MyEventsQueryHookResult = ReturnType<typeof useMyEventsQuery>;
export type MyEventsLazyQueryHookResult = ReturnType<typeof useMyEventsLazyQuery>;
export type MyEventsQueryResult = Apollo.QueryResult<MyEventsQuery, MyEventsQueryVariables>;
export const FollowDocument = gql`
    mutation follow($groupId: ID!) {
  follow(input: {groupId: $groupId}) {
    group {
      id
      followers {
        id
        userId
        groupId
        user {
          id
          fullName
        }
      }
    }
  }
}
    `;
export type FollowMutationFn = Apollo.MutationFunction<FollowMutation, FollowMutationVariables>;

/**
 * __useFollowMutation__
 *
 * To run a mutation, you first call `useFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followMutation, { data, loading, error }] = useFollowMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useFollowMutation(baseOptions?: Apollo.MutationHookOptions<FollowMutation, FollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowMutation, FollowMutationVariables>(FollowDocument, options);
      }
export type FollowMutationHookResult = ReturnType<typeof useFollowMutation>;
export type FollowMutationResult = Apollo.MutationResult<FollowMutation>;
export type FollowMutationOptions = Apollo.BaseMutationOptions<FollowMutation, FollowMutationVariables>;
export const GroupDocument = gql`
    query group($id: ID!) {
  myGroups {
    ...groupFragment
  }
  group(id: $id) {
    ...groupFragment
    users {
      id
      email
      fullName
    }
    requests {
      id
      groupId
      userId
      status
      createdAtText
      user {
        ...userFragment
      }
    }
    groupAdmins {
      id
      user {
        id
        email
        fullName
      }
    }
    groupMembers {
      id
      user {
        id
        email
        fullName
      }
    }
    groupUsers {
      id
      role
      user {
        id
        email
        fullName
      }
    }
    myRequestStatus
    followers {
      id
      userId
      groupId
      user {
        id
        email
        fullName
      }
    }
    activities {
      ...groupActivityFragment
      comments {
        ...groupCommentFragment
        user {
          id
          fullName
          avatar
        }
      }
    }
  }
}
    ${GroupFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${GroupActivityFragmentFragmentDoc}
${GroupCommentFragmentFragmentDoc}`;

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupQuery(baseOptions: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
      }
export function useGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
        }
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>;
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>;
export type GroupQueryResult = Apollo.QueryResult<GroupQuery, GroupQueryVariables>;
export const GroupFeatureEventsDocument = gql`
    query groupFeatureEvents($id: ID!) {
  groupFeatureEvents(id: $id) {
    id
    title
    mainImage
    mainImageUrl
    eventStatus
    eventStatusText
    eventDateText
    eventDateWday
    startTimeText
    location
    locationType
    locationTypeText
    organizer
  }
}
    `;

/**
 * __useGroupFeatureEventsQuery__
 *
 * To run a query within a React component, call `useGroupFeatureEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupFeatureEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupFeatureEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupFeatureEventsQuery(baseOptions: Apollo.QueryHookOptions<GroupFeatureEventsQuery, GroupFeatureEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupFeatureEventsQuery, GroupFeatureEventsQueryVariables>(GroupFeatureEventsDocument, options);
      }
export function useGroupFeatureEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupFeatureEventsQuery, GroupFeatureEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupFeatureEventsQuery, GroupFeatureEventsQueryVariables>(GroupFeatureEventsDocument, options);
        }
export type GroupFeatureEventsQueryHookResult = ReturnType<typeof useGroupFeatureEventsQuery>;
export type GroupFeatureEventsLazyQueryHookResult = ReturnType<typeof useGroupFeatureEventsLazyQuery>;
export type GroupFeatureEventsQueryResult = Apollo.QueryResult<GroupFeatureEventsQuery, GroupFeatureEventsQueryVariables>;
export const GroupPastEventsDocument = gql`
    query groupPastEvents($id: ID!) {
  groupPastEvents(id: $id) {
    id
    title
    mainImage
    mainImageUrl
    eventStatus
    eventStatusText
    eventDateText
    eventDateWday
    startTimeText
    lastEventDateText
    lastEventDateWday
    lastStartTimeText
    location
    locationType
    locationTypeText
    organizer
  }
}
    `;

/**
 * __useGroupPastEventsQuery__
 *
 * To run a query within a React component, call `useGroupPastEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPastEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPastEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupPastEventsQuery(baseOptions: Apollo.QueryHookOptions<GroupPastEventsQuery, GroupPastEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupPastEventsQuery, GroupPastEventsQueryVariables>(GroupPastEventsDocument, options);
      }
export function useGroupPastEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupPastEventsQuery, GroupPastEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupPastEventsQuery, GroupPastEventsQueryVariables>(GroupPastEventsDocument, options);
        }
export type GroupPastEventsQueryHookResult = ReturnType<typeof useGroupPastEventsQuery>;
export type GroupPastEventsLazyQueryHookResult = ReturnType<typeof useGroupPastEventsLazyQuery>;
export type GroupPastEventsQueryResult = Apollo.QueryResult<GroupPastEventsQuery, GroupPastEventsQueryVariables>;
export const GroupsDocument = gql`
    query groups($page: Int, $perPage: Int) {
  groups(page: $page, perPage: $perPage) {
    groups {
      ...groupFragment
      groupAdmins {
        id
        user {
          id
          email
          fullName
        }
      }
    }
    pagination {
      ...paginationFragment
    }
  }
}
    ${GroupFragmentFragmentDoc}
${PaginationFragmentFragmentDoc}`;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
      }
export function useGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>;
export type GroupsQueryResult = Apollo.QueryResult<GroupsQuery, GroupsQueryVariables>;
export const MyFollowsDocument = gql`
    query myFollows {
  myFollows {
    id
    isAdmin
    name
    mainImage
    mainImageUrl
    users {
      id
      email
      fullName
    }
    groupAdmins {
      id
    }
    groupMembers {
      id
    }
    followers {
      id
    }
  }
}
    `;

/**
 * __useMyFollowsQuery__
 *
 * To run a query within a React component, call `useMyFollowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyFollowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyFollowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyFollowsQuery(baseOptions?: Apollo.QueryHookOptions<MyFollowsQuery, MyFollowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyFollowsQuery, MyFollowsQueryVariables>(MyFollowsDocument, options);
      }
export function useMyFollowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyFollowsQuery, MyFollowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyFollowsQuery, MyFollowsQueryVariables>(MyFollowsDocument, options);
        }
export type MyFollowsQueryHookResult = ReturnType<typeof useMyFollowsQuery>;
export type MyFollowsLazyQueryHookResult = ReturnType<typeof useMyFollowsLazyQuery>;
export type MyFollowsQueryResult = Apollo.QueryResult<MyFollowsQuery, MyFollowsQueryVariables>;
export const MyGroupsDocument = gql`
    query myGroups {
  myGroups {
    ...groupFragment
    users {
      id
      email
      fullName
    }
    groupAdmins {
      id
    }
    groupMembers {
      id
    }
    followers {
      id
    }
  }
}
    ${GroupFragmentFragmentDoc}`;

/**
 * __useMyGroupsQuery__
 *
 * To run a query within a React component, call `useMyGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGroupsQuery(baseOptions?: Apollo.QueryHookOptions<MyGroupsQuery, MyGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGroupsQuery, MyGroupsQueryVariables>(MyGroupsDocument, options);
      }
export function useMyGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGroupsQuery, MyGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGroupsQuery, MyGroupsQueryVariables>(MyGroupsDocument, options);
        }
export type MyGroupsQueryHookResult = ReturnType<typeof useMyGroupsQuery>;
export type MyGroupsLazyQueryHookResult = ReturnType<typeof useMyGroupsLazyQuery>;
export type MyGroupsQueryResult = Apollo.QueryResult<MyGroupsQuery, MyGroupsQueryVariables>;
export const UnfollowDocument = gql`
    mutation unfollow($groupId: ID!) {
  unfollow(input: {groupId: $groupId}) {
    group {
      id
      followers {
        id
        userId
        groupId
        user {
          id
          fullName
        }
      }
    }
  }
}
    `;
export type UnfollowMutationFn = Apollo.MutationFunction<UnfollowMutation, UnfollowMutationVariables>;

/**
 * __useUnfollowMutation__
 *
 * To run a mutation, you first call `useUnfollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowMutation, { data, loading, error }] = useUnfollowMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useUnfollowMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowMutation, UnfollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowMutation, UnfollowMutationVariables>(UnfollowDocument, options);
      }
export type UnfollowMutationHookResult = ReturnType<typeof useUnfollowMutation>;
export type UnfollowMutationResult = Apollo.MutationResult<UnfollowMutation>;
export type UnfollowMutationOptions = Apollo.BaseMutationOptions<UnfollowMutation, UnfollowMutationVariables>;
export const IndustryTypesDocument = gql`
    query industryTypes {
  industryTypes {
    id
    name
  }
}
    `;

/**
 * __useIndustryTypesQuery__
 *
 * To run a query within a React component, call `useIndustryTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndustryTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndustryTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIndustryTypesQuery(baseOptions?: Apollo.QueryHookOptions<IndustryTypesQuery, IndustryTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndustryTypesQuery, IndustryTypesQueryVariables>(IndustryTypesDocument, options);
      }
export function useIndustryTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndustryTypesQuery, IndustryTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndustryTypesQuery, IndustryTypesQueryVariables>(IndustryTypesDocument, options);
        }
export type IndustryTypesQueryHookResult = ReturnType<typeof useIndustryTypesQuery>;
export type IndustryTypesLazyQueryHookResult = ReturnType<typeof useIndustryTypesLazyQuery>;
export type IndustryTypesQueryResult = Apollo.QueryResult<IndustryTypesQuery, IndustryTypesQueryVariables>;
export const NotificationsDocument = gql`
    query notifications($page: Int, $perPage: Int) {
  notifications(page: $page, perPage: $perPage) {
    notifications {
      ...notificationFragment
    }
    pagination {
      ...paginationFragment
    }
  }
}
    ${NotificationFragmentFragmentDoc}
${PaginationFragmentFragmentDoc}`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const OptionsDocument = gql`
    query options($search: OptionSearch) {
  options(search: $search) {
    ...optionFragment
  }
}
    ${OptionFragmentFragmentDoc}`;

/**
 * __useOptionsQuery__
 *
 * To run a query within a React component, call `useOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useOptionsQuery(baseOptions?: Apollo.QueryHookOptions<OptionsQuery, OptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OptionsQuery, OptionsQueryVariables>(OptionsDocument, options);
      }
export function useOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OptionsQuery, OptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OptionsQuery, OptionsQueryVariables>(OptionsDocument, options);
        }
export type OptionsQueryHookResult = ReturnType<typeof useOptionsQuery>;
export type OptionsLazyQueryHookResult = ReturnType<typeof useOptionsLazyQuery>;
export type OptionsQueryResult = Apollo.QueryResult<OptionsQuery, OptionsQueryVariables>;
export const MyEntryOrdersDocument = gql`
    query myEntryOrders {
  myEntryOrders {
    ...orderFragment
    event {
      ...eventFragment
      eventSchedules {
        ...eventScheduleFragment
      }
    }
  }
}
    ${OrderFragmentFragmentDoc}
${EventFragmentFragmentDoc}
${EventScheduleFragmentFragmentDoc}`;

/**
 * __useMyEntryOrdersQuery__
 *
 * To run a query within a React component, call `useMyEntryOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEntryOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEntryOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEntryOrdersQuery(baseOptions?: Apollo.QueryHookOptions<MyEntryOrdersQuery, MyEntryOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEntryOrdersQuery, MyEntryOrdersQueryVariables>(MyEntryOrdersDocument, options);
      }
export function useMyEntryOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEntryOrdersQuery, MyEntryOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEntryOrdersQuery, MyEntryOrdersQueryVariables>(MyEntryOrdersDocument, options);
        }
export type MyEntryOrdersQueryHookResult = ReturnType<typeof useMyEntryOrdersQuery>;
export type MyEntryOrdersLazyQueryHookResult = ReturnType<typeof useMyEntryOrdersLazyQuery>;
export type MyEntryOrdersQueryResult = Apollo.QueryResult<MyEntryOrdersQuery, MyEntryOrdersQueryVariables>;
export const RoomCalendarsDocument = gql`
    query roomCalendars($search: RoomCalendarSearch!) {
  roomCalendars(search: $search) {
    ...roomCalendarFragment
    event {
      ...eventFragment
    }
  }
}
    ${RoomCalendarFragmentFragmentDoc}
${EventFragmentFragmentDoc}`;

/**
 * __useRoomCalendarsQuery__
 *
 * To run a query within a React component, call `useRoomCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomCalendarsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useRoomCalendarsQuery(baseOptions: Apollo.QueryHookOptions<RoomCalendarsQuery, RoomCalendarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomCalendarsQuery, RoomCalendarsQueryVariables>(RoomCalendarsDocument, options);
      }
export function useRoomCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomCalendarsQuery, RoomCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomCalendarsQuery, RoomCalendarsQueryVariables>(RoomCalendarsDocument, options);
        }
export type RoomCalendarsQueryHookResult = ReturnType<typeof useRoomCalendarsQuery>;
export type RoomCalendarsLazyQueryHookResult = ReturnType<typeof useRoomCalendarsLazyQuery>;
export type RoomCalendarsQueryResult = Apollo.QueryResult<RoomCalendarsQuery, RoomCalendarsQueryVariables>;
export const AllUsersDocument = gql`
    query allUsers {
  allUsers {
    ...userFragment
    address {
      ...addressFragment
      industryType {
        ...industryTypeFragment
      }
    }
  }
}
    ${UserFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${IndustryTypeFragmentFragmentDoc}`;

/**
 * __useAllUsersQuery__
 *
 * To run a query within a React component, call `useAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
      }
export function useAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
        }
export type AllUsersQueryHookResult = ReturnType<typeof useAllUsersQuery>;
export type AllUsersLazyQueryHookResult = ReturnType<typeof useAllUsersLazyQuery>;
export type AllUsersQueryResult = Apollo.QueryResult<AllUsersQuery, AllUsersQueryVariables>;